var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJhuLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 171,
    xmlns: "http://www.w3.org/2000/svg",
    desc: "Created with imagetracer.js version 1.2.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 31 L 84 31.5 L 78.5 32 L 78.5 31 Z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 31 L 96 31.5 L 90.5 32 L 90.5 31 Z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 65.5 35 L 67 35.5 L 64.5 37 L 65.5 35 Z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 60.5 38 L 59.5 40 L 60.5 38 Z "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114.5 39 L 115.5 41 L 114.5 39 Z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57.5 40 L 55.5 43 L 57.5 40 Z "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 42 L 125.5 50 L 118.5 42 Z "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 44 L 88 46 L 86 45.5 L 87.5 44 Z "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 49.5 48 L 47.5 51 L 49.5 48 Z "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 49 L 91 51.5 L 90 51.5 L 90.5 49 Z "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 51 L 127.5 53 L 126.5 51 Z "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 45.5 53 L 44.5 55 L 45.5 53 Z "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 54 L 80.5 56 L 81.5 54 Z "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 54 L 129.5 56 L 128.5 54 Z "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 56 L 79.5 58 Q 76.7 58.7 78.5 56 Z "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 57 L 95 62 L 90 61.5 L 94 60.5 L 93.5 57 Z "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 59 L 81 60.5 L 79 61.5 L 80.5 59 Z "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 41.5 60 L 42 61.5 L 40.5 64 L 40 62.5 L 41.5 60 Z "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 68 L 90 70.5 L 89 70.5 L 89.5 68 Z "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 71 L 136 73.5 L 135 73.5 L 135.5 71 Z "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 73 Q 92.1 72.2 91 75.5 L 91 77.5 L 92 82.5 L 91 82.5 L 89 75.5 L 89.5 73 Z "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 37.5 75 L 38 79.5 L 37 79.5 L 37.5 75 Z "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 78 L 84 84.5 L 83 84.5 L 83.5 78 Z "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 37.5 81 L 38 85.5 L 37 85.5 L 37.5 81 Z "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 84 Q 89.8 83.3 89 85.5 L 87.5 84 Z "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 85 L 136 88.5 L 135 88.5 L 135.5 85 Z "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 86 L 84 87.5 L 82.5 91 L 82 88.5 L 83.5 86 Z "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 90 L 87 94.5 L 84.5 96 L 84.5 95 Q 86.8 95.8 86 93.5 L 85.5 90 Z "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 90 L 94 94.5 L 93 94.5 L 92.5 92 L 91 92.5 L 93.5 90 Z "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 92 L 83 94.5 L 82 94.5 L 82.5 92 Z "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88 93 L 90 93.5 L 88 94.5 L 88 93 Z "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81 97 L 83 97.5 L 81.5 102 L 81 97 Z "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 97 L 87 99.5 L 85.5 102 L 88 102.5 L 84.5 104 L 84 101.5 Q 87.5 100 85 98.5 L 85.5 97 Z "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 97 Q 96.3 95.8 95 99.5 L 94 99.5 Q 94.8 97.3 92.5 98 L 92.5 97 Z "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 100 Q 93.1 99.2 92 102.5 L 92.5 104 L 89 102.5 L 91 101.5 L 90.5 100 Z "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 101 Q 96.8 101.8 96 105.5 L 95 105.5 L 94.5 101 Z "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 42.5 102 L 45 105.5 L 43 104.5 L 42.5 102 Z "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86 104 L 88 104.5 L 86 105.5 L 86 104 Z "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 104 L 90.5 106 Q 87.7 106.7 89.5 104 Z "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 106 L 87 112 L 84 112.5 L 88 113 L 88.5 111 L 89 113 L 94.5 112 L 93.5 114 Q 88.1 112.1 89 115.5 L 88 115.5 L 87.5 114 L 82 114 L 82 112 L 86 110.5 L 84 110 L 84.5 106 Z "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 106 L 93 110 L 91 110.5 L 91.5 112 Q 88.3 110.3 92 108.5 L 92.5 106 Z "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 45.5 107 L 46.5 109 L 45.5 107 Z "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 107 L 83 108.5 L 81 109 L 80.5 113 L 80.5 107 Z "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 107 L 97 111.5 L 96 111.5 Q 97.1 108.2 94.5 109 L 94.5 108 L 96.5 107 Z "
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 108 L 125.5 111 L 127.5 108 Z "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 47.5 110 L 50.5 114 L 47.5 110 Z "
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 113 L 122.5 115 L 123.5 113 Z "
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 54.5 117 L 56.5 120 L 54.5 117 Z "
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 118 L 115.5 121 L 117.5 118 Z "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 121 L 111.5 124 L 110 123.5 L 113.5 121 Z "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 128 L 99 128.5 L 96.5 129 L 96.5 128 Z "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 129 L 85 129.5 L 80.5 130 L 80.5 129 Z "
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(50,79,8)",
    stroke: "rgb(50,79,8)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 129 L 94 129.5 L 89.5 130 L 89.5 129 Z "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(37,237,15)",
    stroke: "rgb(37,237,15)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 32 L 86 32.5 L 77.5 46 L 64 39 L 65.5 36 L 76.5 32 Z "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(37,237,15)",
    stroke: "rgb(37,237,15)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88 32 L 97.5 32 L 109 36 L 107.5 40 L 95 46 L 88 32 Z "
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(37,237,15)",
    stroke: "rgb(37,237,15)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 60.5 39 L 62 39.5 L 62 55 L 53.5 56 L 51.5 55 L 46 56 L 46 52.5 L 54.5 43 L 60.5 39 Z "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(37,237,15)",
    stroke: "rgb(37,237,15)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112 39 Q 120.9 42 126 50.5 L 128 54.5 L 126.5 56 L 113.5 56 L 112 54.5 L 111 46.5 L 111 44.5 L 112 42.5 L 112 40.5 L 112 39 Z "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(37,237,15)",
    stroke: "rgb(37,237,15)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 44.5 57 L 48 61.5 L 52 71.5 L 38 79 Q 37.4 64.7 44.5 57 Z "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(37,237,15)",
    stroke: "rgb(37,237,15)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 129.5 57 L 134 65.5 L 136 79 L 133.5 79 L 121 72 Q 123.4 63.2 129.5 57 Z "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(37,237,15)",
    stroke: "rgb(37,237,15)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 38 82 Q 46.6 83.5 52 89.5 L 46 103 L 42 101.5 L 38 89.5 L 38 82 Z "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(37,237,15)",
    stroke: "rgb(37,237,15)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 82 Q 137.3 80.3 136 84.5 Q 133.5 86 135 91.5 L 129.5 104 L 121 89.5 L 132.5 82 Z "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(37,237,15)",
    stroke: "rgb(37,237,15)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 46 105 L 60.5 105 L 62 106.5 L 62 121.5 L 60.5 122 L 53 117 L 53 115 Q 50.3 116.1 51 113.5 L 46 107.5 L 46 105 Z "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(37,237,15)",
    stroke: "rgb(37,237,15)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112 105 L 128 105.5 L 128 107.5 L 125 110.5 L 118.5 118 Q 116.4 121.9 111 121 L 112 118.5 Q 109.8 117.3 111 112.5 L 112 111.5 L 112 105 Z "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(37,237,15)",
    stroke: "rgb(37,237,15)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 114 L 110 122.5 Q 110.8 124.8 108.5 124 Q 100.8 129.5 88 129 L 94 116 Q 96.8 117 96.5 114 Z "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(37,237,15)",
    stroke: "rgb(37,237,15)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 115 L 80 117.5 L 86 128.5 L 77.5 129 L 67.5 126 L 64 123.5 L 65.5 121 L 76.5 115 Z "
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 13 L 82 14.5 L 79.5 15 L 77.5 13 Z "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 14 L 73.5 16 L 72.5 14 Z "
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 14 L 100.5 16 L 99 15.5 L 101.5 14 Z "
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68.5 15 L 69.5 17 L 68.5 15 Z "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 16 L 107.5 18 L 108.5 16 Z "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 18 L 112.5 20 L 113.5 18 Z "
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57.5 19 L 58.5 21 L 57.5 19 Z "
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 21 L 95 21.5 L 93.5 24 L 92.5 21 Z "
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 50.5 23 L 51.5 25 L 50.5 23 Z "
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 23 L 113.5 25 L 112.5 23 Z "
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 24 L 123.5 26 L 124.5 24 Z "
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 47.5 25 L 48.5 27 L 47.5 25 Z "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 70.5 25 L 71 27 L 69 26.5 L 70.5 25 Z "
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 25 L 99 26.5 L 97 27.5 L 98.5 25 Z "
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 26 L 75.5 28 L 74.5 26 Z "
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 26 L 106.5 28 L 105.5 26 Z "
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108 26 L 110 26.5 L 108 27.5 L 108 26 Z "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102.5 27 L 101.5 29 L 102.5 27 Z "
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 43.5 28 Q 46.5 29.5 43.5 31 L 41 30.5 L 43.5 28 Z "
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110.5 28 L 111.5 30 L 110.5 28 Z "
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 29 L 90 29.5 L 84.5 30 L 84.5 29 Z "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 49.5 33 L 48.5 35 L 49.5 33 Z "
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 33 L 116.5 35 L 115.5 33 Z "
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 36.5 35 L 37 37.5 L 35.5 39 L 35 36.5 L 36.5 35 Z "
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 50.5 35 L 50.5 38 Q 47.5 36.5 50.5 35 Z "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 44.5 39 L 48 40.5 L 45.5 41 L 44.5 39 Z "
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 39 L 130.5 41 L 131.5 39 Z "
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 40 L 119.5 42 L 118.5 40 Z "
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 43 L 127.5 45 L 126.5 43 Z "
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 45 L 143.5 47 L 144.5 45 Z "
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 28.5 46 L 29.5 48 L 28.5 46 Z "
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86 46 Q 89.3 44.7 88 49.5 L 86.5 55 L 85 53.5 Q 88.8 51.8 85.5 50 L 84 50.5 Q 86.7 49.4 86 46 Z "
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 46 L 125.5 48 L 124.5 46 Z "
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 37.5 48 L 36.5 50 L 37.5 48 Z "
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 48 L 137.5 50 L 136.5 48 Z "
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 51 Q 135.5 52.5 132.5 54 L 132.5 51 Z "
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 51 L 136.5 53 L 137.5 51 Z "
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 52 L 91 53.5 L 89 54.5 L 90.5 52 Z "
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 53 L 147.5 55 L 148.5 53 Z "
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 24.5 54 L 25.5 56 L 24.5 54 Z "
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 54 L 91.5 56 L 92.5 54 Z "
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 30.5 56 L 29.5 58 L 30.5 56 Z "
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 56 Q 81.8 55.3 81 57.5 L 81.5 59 L 79.5 56 Z "
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 32.5 57 L 31.5 59 L 32.5 57 Z "
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 57 L 85.5 59 L 87 58.5 L 83 61.5 Q 85 66 87 62.5 L 86.5 61 L 89 63.5 Q 85.9 65.2 87.5 67 Q 85.3 67.8 86 65.5 L 83 64 L 81 60.5 L 83.5 60 L 85 59.5 L 84.5 57 Z "
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 58 L 91.5 60 L 88 59.5 L 90.5 58 Z "
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 58 L 145 58.5 Q 142.9 61.8 142.5 58 Z "
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 58 L 149.5 60 L 150.5 58 Z "
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 60 L 138.5 62 L 136 61.5 L 137.5 60 Z "
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 61 L 150.5 63 L 151.5 61 Z "
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 64 L 145.5 66 L 144.5 64 Z "
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 67 L 33.5 69 L 34.5 67 Z "
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 20.5 68 L 21.5 70 L 20.5 68 Z "
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 68 L 88.5 70 L 87.5 68 Z "
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 71 L 143.5 73 L 142.5 71 Z "
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 19.5 75 L 20 77.5 L 19 77.5 L 19.5 75 Z "
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 25.5 77 L 28 77.5 L 25.5 78 L 25.5 77 Z "
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 77 L 89 79 L 87 79.5 L 89 80.5 L 85.5 81 L 86 79.5 Q 85.3 77.3 87.5 78 L 88.5 77 Z "
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 78 L 149 78.5 L 146.5 79 L 146.5 78 Z "
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 82 L 86.5 84 L 87.5 82 Z "
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 86 L 91 86.5 L 87 89.5 L 87.5 91 L 86 89.5 L 89.5 86 Z "
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 86 L 153 88.5 L 152 88.5 L 152.5 86 Z "
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 21.5 90 L 22 91.5 L 20 92.5 L 21.5 90 Z "
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89 90 L 91 90.5 L 89 91.5 L 89 90 Z "
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 24 91 L 26 91.5 L 24 92.5 L 24 91 Z "
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33.5 92 L 34 94 L 30.5 95 L 29.5 94 L 27 95.5 Q 28.8 91.3 30.5 94 L 33.5 92 Z "
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87 96 L 89 96.5 L 88.5 99 Q 85.5 99.7 87 96 Z "
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 23.5 99 L 22.5 101 L 23.5 99 Z "
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 28.5 99 L 29 101.5 L 28.5 103 L 27 100.5 L 28.5 99 Z "
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137 99 L 139 99.5 L 137 100.5 L 137 99 Z "
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 99 L 142.5 101 L 141.5 99 Z "
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 29.5 104 L 30.5 106 L 29.5 104 Z "
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 106 L 148.5 108 L 147.5 106 Z "
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 108 L 147.5 110 L 146.5 108 Z "
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 27.5 109 L 26.5 111 L 27.5 109 Z "
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 110 L 146.5 112 L 145.5 110 Z "
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 28.5 111 L 27.5 113 L 28.5 111 Z "
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 112 L 145.5 114 L 144.5 112 Z "
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 29.5 113 L 28.5 115 L 29.5 113 Z "
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 31.5 116 L 30.5 118 L 31.5 116 Z "
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 37.5 124 L 40.5 129 Q 41.8 126.8 43 129.5 L 40.5 130 L 38 127.5 L 39 126.5 L 37.5 124 Z "
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 129 L 142.5 131 L 143.5 129 Z "
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 131 L 131 131.5 L 129.5 133 L 127 132.5 L 128.5 131 Z "
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 132 L 35 134 L 37 134.5 L 35.5 135 L 33 134.5 L 34.5 132 Z "
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 60.5 132 L 59.5 134 L 60.5 132 Z "
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 132 L 108.5 134 Q 106.7 131.3 105 135.5 L 104.5 138 L 104 135.5 L 107.5 132 Z "
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 47.5 133 L 46.5 135 L 47.5 133 Z "
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 26.5 134 L 28 136.5 L 26 135.5 L 26.5 134 Z "
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57.5 134 L 58.5 136 L 57.5 134 Z "
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 62.5 134 L 65 137.5 L 63.5 137 Q 60.4 137.7 62.5 134 Z "
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68.5 134 L 69.5 136 L 68.5 134 Z "
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 134 L 76 134.5 L 73.5 135 L 73.5 134 Z "
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 134 L 147 136.5 L 145 135.5 L 145.5 134 Z "
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 135 L 83.5 136 L 86.5 135 L 85.5 137 L 81.5 136 L 80 136.5 L 81.5 135 Z "
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 136 L 68.5 138 L 67.5 136 Z "
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 136 L 122.5 138 L 121.5 136 Z "
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 53.5 137 L 52.5 139 L 53.5 137 Z "
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 139 L 117.5 141 L 116.5 139 Z "
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 139 L 141.5 141 L 139 140.5 L 140.5 139 Z "
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 71.5 140 L 70.5 142 L 71.5 140 Z "
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 61.5 141 L 60.5 143 L 61.5 141 Z "
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 141 L 124 142.5 L 125 144.5 L 122.5 146 L 123 144.5 L 124.5 141 Z "
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 142 L 126.5 144 L 127.5 142 Z "
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 45.5 143 L 47 146.5 L 45 145.5 L 45.5 143 Z "
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 143 L 107.5 145 L 106.5 143 Z "
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 143 L 138 143.5 Q 135.9 146.8 135.5 143 Z "
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 144 L 104.5 146 L 103.5 144 Z "
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 145 L 133.5 147 L 132.5 145 Z "
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 146 L 92 146.5 L 82.5 147 L 82.5 146 Z "
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 146 L 115 147.5 L 113.5 150 L 112.5 148 L 114 148.5 L 115.5 146 Z "
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56.5 147 L 55.5 149 L 56.5 147 Z "
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 148 L 128.5 150 L 127.5 148 Z "
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 59.5 149 L 60.5 151 L 61.5 149 L 62 150.5 Q 60.5 153.5 59 150.5 L 59.5 149 Z "
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 150 L 103 151.5 L 104 153.5 L 102 152.5 L 103.5 150 Z "
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 150 Q 110.8 149.3 110 151.5 L 108.5 150 Z "
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 69.5 152 L 69.5 155 L 67 154.5 Q 66.3 152.3 68.5 153 L 69.5 152 Z "
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 152 L 94.5 154 L 96 153.5 L 95.5 156 L 92 153.5 L 93.5 152 Z "
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 152 L 120.5 154 L 119.5 152 Z "
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 53.5 153 L 52.5 155 L 53.5 153 Z "
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 153 L 118.5 155 L 117.5 153 Z "
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 58.5 155 L 57.5 157 L 58.5 155 Z "
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 155 L 87.5 157 Q 84.7 157.7 86.5 155 Z "
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(68,51,44)",
    stroke: "rgb(68,51,44)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 61.5 156 L 60.5 158 L 61.5 156 Z "
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75.5 6 Q 78.1 5.2 77 8.5 L 81 8.5 L 81.5 10 L 84 8.5 L 82.5 12 L 80 11.5 L 79.5 10 L 77 10.5 L 78 12.5 L 75 12.5 L 76 10 L 73.5 11 L 72 9.5 L 75.5 6 Z "
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 6 L 99 7.5 L 95.5 8 L 96.5 6 Z "
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 8 L 87 11.5 L 85 10.5 L 86.5 8 Z "
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 8 Q 95.3 7 94 10 L 90 9.5 L 91.5 8 Z "
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 8 L 101.5 11 L 103 10.5 L 102.5 9 L 104.5 8 L 104 9.5 L 102.5 12 Q 99.2 13.1 100 10.5 Q 97.8 9.3 100.5 8 Z "
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 95.5 9 L 98 9.5 L 97 10.5 L 98.5 13 L 95 11 L 95.5 9 Z "
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 10 L 64 11.5 L 63 14.5 Q 65.3 15.8 62.5 17 L 58.5 17 L 55.5 19 L 57.5 16 L 59 15.5 L 58.5 14 L 60 14.5 Q 59.3 12.3 61.5 13 L 64.5 10 Z "
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 65.5 12 L 67.5 15 L 65.5 12 Z "
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 13 L 106 14.5 L 104.5 14 L 103.5 13 Z "
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112 14 L 120 14.5 L 116 15.5 L 119 16.5 L 117.5 19 L 115.5 16 L 113.5 17 L 112 14 Z "
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 15 L 83.5 18 Q 80.5 16.5 83.5 15 Z "
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93 15 L 96 16.5 L 93 17 L 93 15 Z "
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 16 L 73.5 19 Q 70.5 17.5 73.5 16 Z "
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 16 L 78 18 L 75.5 19 L 77.5 16 Z "
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 16 L 124.5 16 L 128 19.5 L 125.5 21 L 124 20.5 L 125.5 23 L 128 21.5 L 127.5 24 L 124.5 23 L 122 21.5 Q 124 17.8 126 19.5 L 124.5 17 L 122 17.5 L 120.5 20 L 119.5 18 L 121 18.5 L 120.5 16 Z "
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 49.5 17 L 51.5 20 L 49.5 21 L 50 19.5 L 49.5 18 L 48 18.5 L 49.5 17 Z "
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 47.5 20 L 49 22.5 L 46 23 L 47.5 20 Z "
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56.5 22 L 58 25.5 L 59 27.5 L 57 26.5 L 56.5 25 L 54.5 28 L 54 26 L 52 25.5 L 53.5 25 Q 54.8 27.2 56 24.5 Q 53.7 23.3 56.5 22 Z "
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 41.5 23 L 42.5 25 L 41.5 23 Z "
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 24 L 120 26 L 116 25.5 L 119.5 24 Z "
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 129.5 24 L 130.5 27 L 133 26 L 131.5 29 L 128 25.5 L 129.5 24 Z "
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 24 L 135.5 26 L 136 24 Q 140.1 22.7 139 26 L 135.5 27 L 134.5 24 Z "
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 26 L 95.5 29 L 99.5 27 L 99 28.5 Q 99.9 31.5 95.5 30 L 94 28.5 L 94.5 26 Z "
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 37.5 27 L 35.5 30 L 37.5 27 Z "
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 65.5 27 L 67 29.5 L 66 29.5 L 65.5 27 Z "
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33.5 28 L 32.5 30 L 33.5 28 Z "
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 39.5 28 L 39.5 31 Q 36.5 29.5 39.5 28 Z "
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48.5 28 L 51 31.5 L 49.5 31 Q 46.4 31.7 48.5 28 Z "
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 28 L 83 28.5 L 80.5 29 L 80.5 28 Z "
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 28 L 127 31.5 L 124 33.5 L 124.5 35 L 123 35.5 L 123.5 37 Q 120.7 35.8 123 34.5 L 124.5 32 L 126 31.5 L 125.5 28 Z "
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 59.5 29 L 60 31.5 L 61 35.5 L 60 35.5 L 59.5 34 L 58 34.5 L 59 31.5 L 57 31.5 L 59.5 29 Z "
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 29 L 77 29.5 L 71.5 31 L 72.5 29 Z "
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 29 L 138.5 29 L 141 30.5 L 143 33.5 L 143 35.5 L 142 38.5 L 142.5 40 L 141 37.5 L 142 35.5 L 137.5 32 L 137.5 34 L 136 30.5 L 136.5 29 Z "
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 31 L 35.5 33 L 33 32.5 L 34.5 31 Z "
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 63.5 31 L 64 33 L 62 32.5 L 63.5 31 Z "
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 31 L 69 31.5 L 65.5 33 L 65.5 32 L 67.5 31 Z "
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33 34 L 36 34.5 L 33.5 36 L 33 34 Z "
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 31.5 35 L 30 39.5 L 29.5 42 L 28 38.5 L 31.5 35 Z "
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 37 Q 135.8 36.3 135 38.5 L 133.5 37 Z "
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 38 L 125 38.5 L 122.5 39 L 122.5 38 Z "
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 40 L 150.5 42 L 149.5 40 Z "
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 25 41 Q 28.8 39.5 28 42.5 L 26 42.5 Q 26.8 46.3 24.5 47 L 25 45.5 L 24 43.5 L 25 41 Z "
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 41 L 123.5 43 Q 120.7 43.7 122.5 41 Z "
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 41 L 140 42.5 L 139.5 45 L 136.5 47 L 138 44.5 L 137 42.5 L 138.5 41 Z "
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 42 Q 149.1 41.4 150.5 44 L 152 43.5 L 151.5 46 Q 149.8 42.9 148 44.5 Q 148.9 41.5 144.5 43 L 144.5 42 Z "
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48.5 44 L 50 44.5 L 48 45 L 45.5 49 L 45 47 Q 47.7 48.1 47 45.5 L 48.5 44 Z "
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 46 L 153 48 L 153 56.5 L 154 57.5 L 152.5 57 Q 149.9 57.8 151 54.5 L 152 51.5 Q 153.1 48.2 150.5 49 L 148 47.5 L 149.5 46 Z "
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 29.5 49 L 30 51.5 L 29 51.5 L 29.5 49 Z "
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 49 L 129.5 51 L 128.5 49 Z "
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 23.5 50 L 24.5 52 L 23.5 50 Z "
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 50 Q 145.8 49.3 145 51.5 L 143.5 50 Z "
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 43.5 51 L 41.5 54 L 43.5 51 Z "
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 20.5 53 L 20.5 58 L 19.5 55 L 18 54.5 L 20.5 53 Z "
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 27.5 53 L 30 53.5 L 27 57.5 L 27.5 59 L 26 57.5 L 27 54.5 L 27.5 53 Z "
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 32.5 53 L 34 56.5 L 33 56.5 L 32.5 54 L 31 54.5 L 32.5 53 Z "
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 53 L 144.5 55 L 143.5 53 Z "
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 16.5 55 L 20 59.5 L 17 61.5 L 18.5 59 Q 15.9 59.8 17 56.5 L 16.5 55 Z "
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 56 L 134.5 58 L 133.5 56 Z "
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 57 L 137 58.5 L 135.5 61 L 135 59.5 L 136.5 57 Z "
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 39.5 58 L 38.5 60 L 39.5 58 Z "
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 60 L 149 61.5 L 147 62.5 L 148.5 60 Z "
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 24.5 61 L 26 63.5 L 24 62.5 L 24.5 61 Z "
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 61 L 142 63.5 L 141 63.5 L 141.5 61 Z "
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 61 L 160 65.5 Q 158.5 68.5 157 65.5 Q 156.3 61.8 158.5 61 Z M 159 63 L 158 66 L 159 66 L 159 63 Z "
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 62 L 139 63.5 L 138.5 65 L 138 63.5 L 139.5 62 Z "
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 18.5 63 L 19.5 65 L 18.5 63 Z "
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 17.5 65 L 19.5 68 L 17.5 65 Z "
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 23.5 65 Q 26.5 66.5 23.5 68 L 23.5 65 Z "
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 35.5 66 Q 38.5 67.5 35.5 69 L 35.5 66 Z "
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 67 L 142.5 70 Q 139.5 68.5 142.5 67 Z "
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 18.5 69 L 17.5 71 L 16 70.5 L 18.5 69 Z "
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 69 L 140.5 71 L 138 70.5 L 139.5 69 Z "
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154 69 L 157 69.5 L 155 70.5 L 157 71 Q 155.9 73.7 158.5 73 L 158.5 71 L 161 72 L 160.5 80 L 159.5 78 L 158 80.5 L 159 82.5 L 157 81.5 L 156.5 80 L 155 80.5 L 158 79.5 L 156.5 77 L 155 77.5 L 157 73.5 L 154 72.5 L 154 70.5 L 154 69 Z M 159 74 L 158 78 L 159 78 L 159 74 Z "
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 24.5 70 L 23.5 72 L 24.5 70 Z "
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 35.5 71 L 36 73 L 34 72.5 L 35.5 71 Z "
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 73 L 145.5 75 L 146.5 73 Z "
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 74 Q 143.5 75.5 140.5 77 L 140.5 74 Z "
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 75 L 150.5 77 L 149 76.5 L 151.5 75 Z "
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 17.5 77 Q 19.8 76.3 19 78.5 L 17 79.5 L 17.5 77 Z "
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 78 L 151 79.5 L 150.5 82 L 149 80.5 L 149.5 78 Z "
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33.5 79 L 34 80.5 L 33.5 83 Q 30.7 81.7 33 80.5 L 33.5 79 Z "
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 80 L 142.5 82 L 143.5 80 Z "
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 21.5 81 L 22.5 83 L 21.5 81 Z "
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 81 L 139.5 83 L 138.5 81 Z "
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 83 L 152 83.5 L 150 84.5 L 151.5 87 Q 147 85 150.5 83 Z "
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 84 L 35 85.5 L 33 86.5 L 34.5 84 Z "
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 84 L 143 87.5 L 142 87.5 L 140.5 84 Z "
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 157.5 84 Q 160.3 85.2 158 86.5 L 160 90.5 L 159 93 Q 162.7 91.7 161 97.5 L 160 97.5 L 159.5 94 L 155.5 97 L 156 95.5 L 155.5 93 L 154 93.5 L 155 91.5 L 154.5 90 L 156.5 91 L 157 88.5 Q 157.8 86.3 155.5 87 L 155.5 86 Q 158 86.7 157.5 84 Z M 158 91 L 157 95 L 159 94 L 158 91 Z "
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 26.5 86 L 29 87 L 28.5 89 L 26 88.5 L 26.5 86 Z "
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 91 Q 143 94.5 144.5 92 L 146 92.5 L 144 93.5 L 144.5 95 L 142 94 L 141.5 91 Z "
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 91 L 149.5 93 L 150.5 91 Z "
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 92 L 37 92.5 L 34.5 93 L 34.5 92 Z "
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 93 L 84.5 95 L 83.5 93 Z "
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 16.5 94 L 19 95.5 L 17.5 96 L 16.5 94 Z "
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 94 L 137.5 96 L 136.5 94 Z "
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 35.5 95 Q 37.8 94.3 37 96.5 L 34 96.5 L 35.5 95 Z "
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 95 Q 151.5 96.5 148.5 98 L 148.5 95 Z "
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 157 97 Q 159.7 95.9 159 98.5 L 160 100.5 L 159 100.5 L 158.5 99 L 157.5 102 L 157 97 Z "
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 20.5 98 L 20 99.5 L 22 102.5 L 20 103 L 19.5 101 L 17.5 105 L 18 103.5 L 20.5 98 Z "
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 24.5 98 L 27 98.5 Q 27.8 100.8 25.5 100 L 24.5 98 Z "
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 98 L 136.5 100 L 135.5 98 Z "
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 98 L 145 99.5 L 143 100.5 L 144.5 98 Z "
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 38.5 99 L 37.5 101 L 36 100.5 L 38.5 99 Z "
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 99 L 152.5 101 L 153.5 99 Z "
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 100 L 140 102.5 L 139.5 105 Q 137.3 105.8 138 103.5 L 139.5 100 Z "
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134 101 L 136 101.5 L 133 103.5 L 134 101 Z "
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 102 L 145 103.5 L 141 106.5 Q 141.8 108.8 139.5 108 L 137.5 108 Q 134.2 106.9 135 109.5 L 134 109.5 L 135.5 106 L 139.5 107 Q 144.3 104.5 142.5 102 Z "
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 103 L 153 111.5 L 151.5 115 L 150 114.5 L 149.5 116 L 149 114.5 L 152 107.5 L 150.5 108 L 149 107.5 L 151 106.5 L 150.5 105 L 152 105.5 L 152.5 103 Z "
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 20.5 104 L 23 104.5 L 20.5 105 L 20.5 104 Z "
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 40.5 104 L 42 106.5 L 41 106.5 L 40.5 105 L 39 105.5 L 40.5 104 Z "
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 16.5 106 L 18.5 106 L 22.5 108 L 22.5 106 L 24 109 L 21.5 110 L 18.5 107 Q 16.7 109.5 16.5 106 Z "
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 31.5 107 L 34 107.5 Q 30.5 109 33 110.5 Q 33.8 113.1 30.5 112 L 29 109.5 L 30 109.5 Q 29.3 111.8 31.5 111 L 31.5 107 Z "
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 107 L 143 108.5 L 142.5 110 L 142 108.5 L 143.5 107 Z "
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 42.5 108 L 41.5 110 L 42.5 108 Z "
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 108 L 130.5 110 L 132 110.5 Q 130.5 113.5 129 110.5 L 130.5 108 Z "
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 36.5 109 Q 40.7 107.9 39 112 L 35.5 113 L 35 110.5 L 36.5 109 Z "
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 19.5 110 L 24 113.5 L 21.5 112 L 19.5 111 L 18.5 113 L 17.5 111 L 19.5 110 Z "
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 23.5 110 L 26 111.5 L 24.5 111 L 23.5 110 Z "
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 112 L 128 114 L 131.5 113 L 136 114.5 L 132.5 115 L 130.5 115 L 127.5 114 L 126 114.5 L 127.5 112 Z "
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 112 L 142 114.5 L 140.5 115 L 138.5 112 Z "
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 43.5 113 L 50.5 120 L 52 119.5 Q 50.3 122.8 48.5 119 Q 45.2 117.9 46 120.5 L 49 121.5 L 48 123.5 L 50 123.5 L 48.5 127 L 45.5 121 L 43.5 120 L 41.5 120 L 39.5 121 L 36.5 116 L 34 117.5 L 35 116.5 L 33.5 114 L 36 115.5 L 36.5 114 L 38 118 Q 41.4 118.8 42.5 116 L 42 117.5 L 42.5 120 L 47 117.5 L 45.5 117 L 44 117.5 L 45 115 Q 41.8 116 43.5 113 Z "
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 46.5 113 L 48.5 116 L 46.5 113 Z "
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 25.5 114 L 26 116 L 29 116.5 L 28 118.5 L 30 118.5 L 28 120.5 L 29.5 123 L 28 122.5 L 29 124.5 L 26 125.5 L 28 126.5 L 26 129.5 L 27 132 Q 23.3 133.5 24 130.5 L 25 128.5 L 24.5 127 L 26 127.5 Q 26.8 125.3 24.5 126 L 24.5 125 L 26 124.5 L 25.5 122 L 24 121.5 L 26 118.5 L 24 117.5 Q 24.8 119.8 22.5 119 L 24 116.5 L 25.5 114 Z M 26 119 Q 24 123 28 122 L 28 120 L 26 119 Z "
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 114 L 151 119.5 L 151 124 Q 148.3 125.1 149 122.5 L 150 119.5 L 148 120.5 Q 149.3 125.3 146 124 L 147 120.5 L 145 116.5 L 146.5 114 Z M 147 116 L 147 119 Q 150 118 147 116 Z "
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 116 L 140 118 L 138 117.5 L 139.5 116 Z "
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 118 L 128 119 L 127.5 122 L 125 121.5 L 124.5 118 Z "
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 36.5 119 L 37.5 121 L 35 120.5 L 36.5 119 Z "
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 119 L 124 121.5 L 123 121.5 L 122.5 119 Z "
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 119 L 136 121.5 L 134.5 121 Q 129.7 119.3 131 123.5 L 128.5 125 L 128.5 124 Q 131.1 124.8 130 121.5 L 129.5 120 Q 131 122.5 132.5 119 Z "
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 120 L 118.5 122 L 119.5 120 Z "
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 121 L 141.5 124 L 143.5 121 Z "
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 51.5 122 L 54 123.5 L 53.5 126 L 53 123 L 51.5 122 Z "
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 123 L 122 123.5 L 123.5 126 L 125 126 Q 123.5 122.2 126.5 123 L 126 124.5 Q 127.3 128.7 122.5 127 L 120 126 L 121 128.5 L 119.5 129 Q 115.2 127.3 118 125.5 L 117.5 123 Z "
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 51.5 124 L 51.5 127 Q 48.5 125.5 51.5 124 Z "
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 45.5 125 Q 48.5 124.1 47 128.5 L 46 128.5 L 45.5 126 L 43.5 129 L 44 127.5 L 45.5 125 Z "
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 59.5 125 L 63 126.5 L 61 127 Q 62.1 129.7 59.5 129 L 60 127.5 L 59.5 125 Z "
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56 126 L 58 126.5 L 57.5 129 Q 54.5 129.7 56 126 Z "
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 129.5 126 L 128.5 128 L 127 127.5 L 129.5 126 Z "
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 126 L 146.5 128 L 147.5 126 L 149 128.5 L 146.5 130 L 145.5 126 Z "
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33 127 L 35 127.5 L 33 128.5 L 33 127 Z "
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 127 L 64 128.5 L 63.5 130 L 63 128.5 L 64.5 127 Z "
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 127 L 110.5 129 L 109.5 127 Z "
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 127 L 116 128.5 L 114 129.5 L 115.5 127 Z "
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 128 L 125 131 L 123 130.5 L 124.5 128 Z "
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 128 L 136 130 L 134 129.5 L 135.5 128 Z "
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 128 Q 153 129 152 133.5 L 151 135.5 L 153 135.5 L 151 138.5 L 152 140.5 L 151 142.5 L 151.5 144 L 150 140.5 L 150.5 139 L 149 138.5 L 151 138 L 150.5 136 L 148.5 137 L 149.5 133 L 151 133.5 Q 151.7 130.9 149 132 L 149 130 L 151 129.5 L 150.5 128 Z "
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 35.5 129 Q 40.5 131.5 35.5 134 L 36.5 131 Q 33.7 131.7 35.5 129 Z "
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 50.5 129 L 49.5 131 L 50.5 129 Z "
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68.5 129 L 68.5 132 Q 65.5 130.5 68.5 129 Z "
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 129 L 138.5 131 L 137.5 129 Z "
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 52.5 130 L 54 130.5 L 53.5 132 L 55 132.5 L 53 133.5 L 53.5 135 L 51 134.5 L 52.5 132 L 49.5 134 L 52.5 130 Z "
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 130 Q 123.3 131.3 121 132.5 L 122 134.5 L 119 134.5 L 120.5 130 Z "
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 32 131 L 34 131.5 L 32 132.5 L 32 131 Z "
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97 131 L 101 132.5 L 99.5 133 L 97 132.5 L 97 131 Z "
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 131 L 141.5 133 Q 142.8 130.8 144 133.5 L 140 134.5 L 140.5 131 Z "
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 131 L 157 136 Q 152.9 137.2 155.5 131 Z "
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 132 Q 82.8 131.3 82 133.5 L 80.5 132 Z "
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92 132 Q 95.8 130.5 95 133.5 L 92 133.5 L 92 132 Z "
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 23.5 133 Q 26.5 134.5 23.5 136 L 22 135.5 L 23.5 133 Z "
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 133 L 113.5 136 L 111.5 133 Z "
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 40.5 134 L 41.5 136 L 40.5 134 Z "
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 44.5 135 L 46 135.5 L 42.5 138 L 44.5 135 Z "
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 66.5 136 L 65.5 138 L 66.5 136 Z "
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115 136 Q 118 135 117 138 Q 114 139 115 136 Z "
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 47.5 137 L 45.5 140 L 47.5 137 Z "
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 137 L 74 138.5 L 73.5 141 Q 70.8 139.8 73 138.5 L 73.5 137 Z "
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33.5 138 Q 35.8 137.3 35 139.5 L 33.5 138 Z "
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57.5 138 Q 60.8 136.9 60 139.5 L 58.5 139 L 57.5 138 Z "
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 138 L 111 138.5 L 107.5 140 L 107.5 139 L 109.5 138 Z "
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 138 L 125.5 140 L 123.5 141 L 124 139.5 L 124.5 138 Z "
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 138 L 149 140.5 L 147 141 L 147.5 138 Z "
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 52.5 139 L 53.5 141 L 52.5 139 Z "
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 25.5 140 L 27 140.5 L 25 143.5 L 26.5 143 L 28 143.5 L 26 144.5 L 29 145.5 L 24 146 L 23 143.5 L 25.5 140 Z "
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 36.5 140 L 39 140.5 Q 39.8 142.8 37.5 142 L 36.5 140 Z "
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 141 L 97 145 Q 94.3 146.1 95 143.5 L 94.5 141 Z "
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 53.5 142 L 56 142.5 L 53.5 143 L 53.5 142 Z "
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 142 L 130.5 144 L 131.5 142 Z "
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147 142 L 149 142.5 L 147 143.5 L 147 142 Z "
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 62.5 144 L 64 148.5 L 63 148.5 L 62.5 144 Z "
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 144 L 141 146.5 L 141.5 148 L 144 146.5 L 143 148.5 Q 145.8 150.3 141.5 152 L 140 149.5 L 140 147.5 L 139 145.5 Q 140.8 147.1 142.5 144 Z "
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33.5 145 Q 35.8 144.3 35 146.5 Q 31.9 148.3 33.5 150 L 32 148.5 Q 35.1 146.8 33.5 145 Z "
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 66.5 145 L 68 148.5 L 67.5 150 L 66.5 145 Z "
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 58.5 146 L 61 146.5 Q 58.9 149.8 58.5 146 Z "
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 146 L 138 146.5 L 134.5 148 L 135.5 146 Z "
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 36.5 147 L 37 149.5 L 35 148.5 L 36.5 147 Z "
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 147 L 125.5 149 L 123.5 150 L 123 148 L 126.5 147 Z "
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 148 L 75.5 149 L 79 148.5 L 78 150.5 L 78.5 152 L 76.5 149 L 73 150 L 73.5 148 Z "
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 148 L 99 149.5 L 97 150.5 L 98.5 148 Z "
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48.5 149 L 51.5 150 Q 52.8 147.7 54 150.5 L 52 150.5 L 51.5 152 L 50.5 150 Q 48.7 152.5 48.5 149 Z "
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 149 L 86.5 150 L 88 149.5 L 87.5 152 L 84.5 149 Z "
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 149 L 116.5 152 L 118.5 149 Z "
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 27.5 150 Q 32 149 33 151.5 L 31.5 152 L 27.5 151 L 27.5 150 Z "
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 150 L 90.5 152 L 89.5 150 Z "
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 150 L 133 151.5 L 125.5 154 L 127.5 151 L 130.5 150 Z "
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 40.5 151 L 42 151.5 L 38.5 154 L 37.5 152 L 40.5 151 Z "
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 43.5 151 L 44.5 153 L 43.5 151 Z "
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136 151 L 140 152.5 L 136 153 L 136 151 Z "
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 152 L 113.5 154 L 112.5 152 Z "
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 42.5 153 L 44 155.5 L 42 156.5 L 42.5 155 L 41 154.5 L 42.5 153 Z "
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 61.5 154 L 62.5 156 L 61.5 154 Z "
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120 154 L 122 154.5 Q 117.7 156.8 119.5 159 L 118 157.5 L 118.5 155 L 120 155.5 L 120 154 Z "
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 155 L 139 155.5 L 135.5 157 L 134.5 155 Z "
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 45.5 157 L 48 157.5 L 47.5 160 L 45 159 L 45.5 157 Z "
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 49.5 157 L 51 159.5 L 49 158.5 L 49.5 157 Z "
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 51.5 157 L 52.5 159 L 51.5 157 Z "
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57.5 157 L 55.5 160 L 57.5 157 Z "
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 157 L 81.5 159 L 82.5 157 Z "
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 157 L 89.5 158 L 91 157.5 L 87 159 L 87.5 157 Z "
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 157 L 125 157.5 L 123.5 160 L 121 158.5 L 122.5 157 Z "
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 40.5 158 L 42.5 158 L 44 158.5 L 41.5 160 L 40.5 158 Z "
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 161 L 100 162.5 L 100.5 161 Q 102.3 164.1 104 162.5 L 104.5 165 L 106.5 162 L 112 163.5 L 109 164.5 L 109.5 166 Q 104.8 167.3 103.5 165 L 101.5 166 L 97.5 164 L 95 165 L 94.5 168 L 92.5 167 L 90.5 168 L 90.5 166 L 87 165 L 87.5 163 L 90.5 164 L 92 163.5 L 91 166 L 95 164.5 L 95.5 162 L 97.5 163 L 97.5 161 Z "
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 161 L 112 161.5 L 109.5 162 L 109.5 161 Z "
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 162 Q 66 164.5 71.5 163 L 73.5 163 Q 77.7 161.9 76 166 Q 73.3 167.1 74 164.5 L 73 164.5 L 72 166.5 L 72.5 168 Q 69.8 166.8 72 165.5 Q 72.6 162.8 66.5 164 L 64 165.5 L 68 167.5 L 66.5 168 L 64.5 167 L 62.5 168 L 63 166.5 L 65 163.5 L 64.5 162 Z "
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 163 L 83 163.5 L 78 164.5 L 82 165.5 L 78.5 167 L 77 164.5 L 78.5 163 Z "
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 165 L 70 165.5 L 67.5 166 L 67.5 165 Z "
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,253,253)",
    stroke: "rgb(253,253,253)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83 166 L 89 167.5 L 83 168 L 83 166 Z "
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,252,6)",
    stroke: "rgb(250,252,6)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 35 L 94.5 47 L 97.5 48 L 100.5 45 L 110 41 L 110 54.5 L 112.5 57 L 124.5 57 L 126 58.5 L 120 68.5 L 120 72.5 L 131 79.5 L 128.5 83 L 120 88.5 L 120 91.5 L 126 102.5 L 115.5 104 L 113.5 103 L 110 105.5 L 110 117.5 L 108.5 119 L 98 114 L 99 108 Q 95.7 109.3 97 104.5 L 96 101.5 L 96 99.5 L 97 96.5 L 95 96.5 L 95 94.5 L 94 90.5 L 94 88.5 L 95 86.5 L 93 83.5 L 93 81.5 L 92 78.5 Q 94.5 77 91 75.5 Q 92.2 67.8 89 64.5 Q 90.5 60.8 96 62 Q 96.8 58.9 94 59.5 L 94 54.5 L 91 51.5 L 92 50.5 Q 93.1 47.2 90.5 48 L 88 49.5 L 89 45.5 L 88 43 Q 84.7 41.7 86 46.5 L 84 51 L 81 52.5 Q 82.1 55.8 79.5 55 L 77 56 Q 75.5 59.8 78.5 59 L 80 58.5 L 78 62 L 83 62.5 L 82 65 L 85 65.5 L 84 66.5 L 82.5 81 L 81.5 77 L 81 81.5 Q 83.2 82.7 82 87.5 L 80 90.5 L 81 91.5 L 81 99.5 L 78.5 114 L 77.5 112 L 77 114 L 64 119 L 63 105.5 L 61.5 104 L 56.5 103 L 52.5 104 L 48 103 L 48 100.5 L 54 91.5 L 54 88.5 L 41 80.5 L 54 71.5 L 54 68.5 L 49 61.5 L 48 57 L 60.5 57 L 64 54.5 L 64 41.5 L 65.5 41 L 75.5 47 L 78.5 47 L 86.5 35 Z M 83 71 L 82 74 L 83 74 L 83 71 Z "
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(250,252,6)",
    stroke: "rgb(250,252,6)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 115 Q 85.9 113.5 85 116.5 L 86 116.5 L 86.5 115 L 89.5 117 L 92.5 115 L 92.5 116 L 91 116.5 L 91 118.5 L 87.5 125 L 84 122.5 L 82 117.5 L 82.5 116 L 81.5 115 Z "
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 14 L 92 14.5 L 82.5 15 L 82.5 14 Z "
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75.5 25 L 76.5 27 L 75.5 25 Z "
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 71.5 28 L 70.5 30 L 71.5 28 Z "
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 29 L 84 29.5 L 80.5 30 L 80.5 29 Z "
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 29 L 93 29.5 L 90.5 30 L 90.5 29 Z "
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 30 L 137.5 36 L 132.5 30 Z "
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 42.5 31 L 37.5 37 L 42.5 31 Z "
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 31 L 88 31.5 L 85.5 32 L 85.5 31 Z "
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 53.5 32 L 54 33.5 L 52 34.5 L 53.5 32 Z "
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56.5 33 L 55.5 35 L 56.5 33 Z "
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114.5 34 L 115.5 36 L 114.5 34 Z "
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 35 L 119.5 37 L 117 36.5 L 120.5 35 Z "
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 42.5 36 L 46 38.5 L 43.5 37 L 42.5 36 Z "
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 37 L 33.5 39 L 34.5 37 Z "
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 38 L 134 40.5 L 133 40.5 L 132.5 38 Z "
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 40 L 33.5 42 L 34.5 40 Z "
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 39.5 40 L 41.5 45 L 39 42.5 L 39.5 40 Z "
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 40 L 125.5 42 L 126.5 40 Z "
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 52.5 42 L 47.5 48 L 52.5 42 Z "
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 46.5 43 Q 49.5 44.5 46.5 46 L 46.5 43 Z "
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 46 L 35.5 48 L 34.5 46 Z "
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 48 L 127.5 50 L 126.5 48 Z "
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 35.5 49 L 34.5 51 L 35.5 49 Z "
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 41.5 49 L 42.5 51 L 41.5 49 Z "
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 45.5 50 L 44.5 52 L 45.5 50 Z "
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 51 L 87 51.5 L 84 53.5 L 85.5 51 Z "
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 52 L 140.5 54 L 139.5 52 Z "
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 53 L 135.5 55 L 136.5 53 Z "
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 45.5 54 L 44.5 56 L 45.5 54 Z "
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 55 L 129.5 57 L 128.5 55 Z "
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 55 L 142.5 57 L 143.5 55 Z "
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 36.5 57 L 37.5 59 L 35 58.5 L 36.5 57 Z "
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 58 L 84.5 60 Q 81.7 60.7 83.5 58 Z "
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 58 L 90 58.5 L 87.5 59 L 87.5 58 Z "
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 27.5 66 L 28.5 68 L 27.5 66 Z "
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 67 Q 87.5 68.5 84.5 70 L 84.5 67 Z "
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 67 L 88.5 69 L 89.5 67 Z "
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 67 L 147.5 69 L 146.5 67 Z "
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 71 L 91 72.5 L 89.5 72 L 88.5 71 Z "
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 26.5 73 L 26 74.5 L 25.5 76 L 25 74.5 L 26.5 73 Z "
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 74 L 153 77.5 L 152 77.5 L 152.5 74 Z "
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 77 L 86 78.5 L 84.5 79 L 83.5 77 Z "
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 77 L 140.5 79 L 141.5 77 Z "
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 79 L 136 81.5 L 135 81.5 L 135.5 79 Z "
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 24.5 81 L 24 82.5 L 23.5 85 L 23 82.5 L 24.5 81 Z "
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 82 L 149 82.5 L 143.5 83 L 143.5 82 Z "
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 84 L 138 86.5 L 137 86.5 L 137.5 84 Z "
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 26.5 85 L 30 85.5 L 26.5 86 L 26.5 85 Z "
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 85 L 84.5 87 L 83 86.5 Q 82.3 88.8 84.5 88 L 84.5 89 L 82 87.5 L 83.5 85 Z "
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86 86 L 88 86.5 L 86 87.5 L 86 86 Z "
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 88 Q 91.3 89.3 89 90.5 L 91 93.5 L 89.5 93 Q 86.9 93.8 88 90.5 L 88.5 88 Z "
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 89 L 142 90.5 L 140.5 91 L 139.5 89 Z "
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 90 L 87 92.5 L 85 93.5 L 86.5 90 Z "
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 95 L 81.5 97 L 82.5 95 Z "
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 95 L 90.5 96 L 92 95.5 L 91 97.5 L 91.5 99 L 88 97.5 L 88.5 96 L 85.5 97 L 85.5 96 L 87.5 95 Z "
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 95 Q 95.8 94.3 95 96.5 L 93.5 95 Z "
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 100 L 90 100.5 L 87.5 102 L 86.5 100 Z "
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 100 L 95.5 102 L 93 101.5 L 94.5 100 Z "
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 101 L 145.5 103 L 144.5 101 Z "
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80 104 Q 83.3 102.9 82 107 Q 78.7 108.1 80 104 Z "
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 105 L 127.5 107 L 128.5 105 Z "
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 106 L 88 110 L 85 108.5 L 85.5 106 Z "
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 106 L 90.5 107 L 92 106.5 L 90.5 110 L 90.5 108 L 88.5 106 Z "
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 113 L 123.5 116 L 125.5 113 Z "
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 117 L 118.5 121 L 121.5 117 Z "
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 31.5 119 L 32.5 121 L 31.5 119 Z "
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 55.5 120 L 56.5 122 L 55.5 120 Z "
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 121 L 111.5 123 L 112.5 121 Z "
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 122 L 135.5 125 L 137.5 122 Z "
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 124 L 38 126.5 L 35.5 125 L 34.5 124 Z "
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 129 L 129.5 131 L 130.5 129 Z "
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 41.5 130 L 42.5 132 L 41.5 130 Z "
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 62.5 130 L 63 133.5 L 62 133.5 L 62.5 130 Z "
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 131 L 89 131.5 L 85.5 132 L 85.5 131 Z "
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 132 L 68.5 134 L 67.5 132 Z "
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136 132 L 138 132.5 L 137 133.5 L 138.5 136 L 136 132 Z "
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 28.5 134 L 30 136.5 L 28 135.5 L 28.5 134 Z "
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 134 L 72.5 137 L 70 136.5 L 72.5 134 Z "
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 134 L 96 134.5 L 93.5 135 L 93.5 134 Z "
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 134 Q 110.5 135.5 107.5 137 L 106 136.5 L 108 135.5 L 107.5 134 Z "
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 135 L 33.5 137 L 34.5 135 Z "
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 135 L 113.5 138 L 111.5 135 Z "
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 135 L 136 138.5 L 135 138.5 L 134.5 135 Z "
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 36.5 136 L 37 139.5 L 36 139.5 L 36.5 136 Z "
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 39.5 137 L 49 143.5 L 50 145.5 L 47 145.5 L 48 144.5 L 44.5 141 L 38 138.5 L 39.5 137 Z "
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56.5 137 L 58 137.5 L 55.5 139 L 56.5 137 Z "
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 137 L 132.5 140 L 134 139.5 L 132.5 141 Q 130.8 137.3 129 140.5 L 131 141.5 L 128 142 L 127 139.5 L 129 139.5 L 130.5 137 Z "
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 137 L 144.5 139 L 145.5 137 Z "
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 31.5 138 L 32.5 140 L 31.5 138 Z "
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 138 L 105 140.5 L 104 140.5 L 104.5 138 Z "
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 140 L 95.5 142 L 94.5 140 Z "
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 140 L 99.5 143 L 97.5 140 Z "
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 32.5 141 L 33.5 143 L 32.5 141 Z "
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 141 L 139.5 143 L 140.5 141 Z "
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 142 L 127 144.5 L 125 145 L 125.5 142 Z "
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 37.5 143 L 38.5 145 L 37.5 143 Z "
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 144 L 87 144.5 L 83.5 145 L 83.5 144 Z "
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 145 L 123 146.5 Q 121.8 149.3 120.5 147 L 117.5 148 L 118 146.5 L 118.5 145 Z "
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57.5 147 L 58.5 149 Q 59.8 146.8 61 149.5 L 60 151.5 L 60.5 153 L 58 152 L 57.5 147 Z "
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 51 148 L 53 148.5 L 51 149.5 L 51 148 Z "
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 148 L 107.5 150 L 108.5 148 Z "
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64 150 Q 68.5 148.3 67 153.5 Q 65.5 156.5 64 153.5 L 64 151.5 L 64 150 Z "
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102.5 150 L 105 150.5 L 104 152.5 L 106 153.5 L 104.5 154 L 102.5 151 L 99 152 L 98.5 154 L 95 152.5 L 102.5 150 Z "
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 70.5 151 L 74 152 L 73.5 155 L 72.5 153 L 71 153.5 L 70.5 151 Z "
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 151 Q 109.8 150.3 109 152.5 L 107.5 151 Z "
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 152 L 93 152.5 L 87.5 155 L 87.5 154 L 90.5 152 Z "
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 153 Q 86.3 151.8 85 155.5 L 84 155.5 Q 84.8 153.3 82.5 154 L 82.5 153 Z "
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(111,114,96)",
    stroke: "rgb(111,114,96)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 161 L 91 161.5 L 80.5 162 L 80.5 161 Z "
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 3 L 78 4.5 L 79 9.5 L 77 10.5 L 77 8.5 Q 78.1 5.2 75.5 6 L 72 8 Q 71.3 4.2 74.5 3 Z "
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96 3 L 101 3 L 101 4.5 L 102 8 L 96.5 6 Q 95 9.5 88.5 8 L 88.5 7 L 96 5 L 96 3 Z "
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 61.5 8 L 64 9.5 L 62.5 9 L 61.5 8 Z "
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110 8 L 114 9.5 L 112.5 10 L 110 9.5 L 110 8 Z "
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 9 L 94.5 12 L 92 11.5 L 94.5 9 Z "
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 65.5 10 L 67.5 11 L 69.5 10 L 69.5 11 L 66.5 12 L 65.5 10 Z "
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 10 L 73.5 12 L 74.5 10 Z "
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57.5 11 L 60 11.5 L 57.5 12 L 57.5 11 Z "
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 13 Q 121 12 122 15.5 L 120 16 Q 121.3 12.3 115.5 14 L 115.5 13 Z "
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 15 Q 82.8 14.3 82 16.5 L 80.5 15 Z "
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 50.5 16 Q 53.1 15.2 52 18.5 L 51 18.5 L 50.5 16 Z "
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 54.5 16 L 55.5 18 Q 52.7 18.7 54.5 16 Z "
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 16 L 77 16.5 Q 74.9 19.8 74.5 16 Z "
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 40.5 18 L 44 20.5 L 42.5 21 L 40 20 L 40.5 18 Z "
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 18 L 121 18.5 Q 118.9 21.8 118.5 18 Z "
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 47.5 19 L 49 19.5 L 46 21.5 L 47 24.5 L 44 24.5 L 47.5 19 Z "
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 53 19 L 55 19.5 L 53 20.5 L 53 19 Z "
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 63.5 19 L 66 19.5 L 63.5 20 L 63.5 19 Z "
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 19 L 84.5 21 L 85.5 19 Z "
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 20 L 125.5 22 L 126.5 20 Z "
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 21 L 136 24 Q 133.3 25.1 134 22.5 L 135.5 21 Z "
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 66.5 22 L 68 24.5 L 67 24.5 L 66.5 22 Z "
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 58.5 23 L 57.5 25 L 58.5 23 Z "
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 32.5 24 L 34.5 25 L 36 24.5 L 35 25.5 L 36.5 28 L 32.5 24 Z "
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 50.5 26 L 49.5 28 L 50.5 26 Z "
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 26 L 136.5 28 L 137.5 26 Z "
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 27 L 141 29.5 L 139 28.5 L 140.5 27 Z "
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 28 L 108 29.5 L 105 31.5 L 107.5 28 Z "
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 61.5 30 L 61.5 33 Q 58.5 31.5 61.5 30 Z "
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 129.5 31 L 130.5 33 L 129.5 31 Z "
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 27 32 L 30 33.5 L 28.5 36 L 27 36 L 27 32 Z "
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 32 L 111 33.5 L 109.5 34 L 108.5 32 Z "
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 34 L 124.5 36 L 125.5 34 Z "
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 24.5 35 Q 27.2 36.3 25 37.5 L 24.5 40 L 24.5 35 Z "
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 28.5 37 L 28 38.5 L 27.5 40 L 27 38.5 L 28.5 37 Z "
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 37 L 121 37.5 L 118.5 38 L 118.5 37 Z "
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 40.5 38 L 43 39.5 L 41.5 39 L 40.5 38 Z "
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 39 L 137.5 41 L 135.5 41 L 134 40.5 L 136.5 39 Z "
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 36.5 40 L 35.5 42 L 36.5 40 Z "
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 40 L 145.5 42 L 144.5 40 Z "
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 24.5 44 L 24 45.5 Q 25 49.3 22 48 L 24.5 44 Z "
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 44 L 154 48 L 151 47.5 L 152 45.5 L 150 45.5 L 151.5 44 Z "
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 31.5 46 L 31 47.5 L 30.5 49 L 30 47.5 L 31.5 46 Z "
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 18.5 48 L 19 51.5 L 18 51.5 Q 18.8 49.3 16.5 50 L 16.5 49 L 18.5 48 Z "
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 20.5 48 L 21.5 50 L 20.5 48 Z "
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 48 L 157 57 L 159 57.5 L 157.5 58 Q 154.5 57.5 155 53.5 L 156.5 48 Z "
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 32.5 50 L 33.5 52 L 32.5 50 Z "
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 52 L 154 55.5 L 153 55.5 L 153.5 52 Z "
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 18.5 53 L 17.5 55 L 18.5 53 Z "
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 59 L 158 59.5 L 157.5 62 L 155 61 L 155.5 59 Z "
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 61 Q 163.1 60.2 162 63.5 L 163 65.5 L 159 68 L 160 63.5 Q 157.8 62.2 160.5 61 Z "
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 16.5 62 L 19 62.5 L 18 65 L 16 64.5 L 16.5 62 Z "
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 62 L 155.5 64 Q 152.7 64.7 154.5 62 Z "
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 30.5 64 L 33 65.5 L 31.5 66 L 29 65.5 L 30.5 64 Z "
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 65 L 156.5 68 L 158 67.5 Q 158.8 69.8 156.5 69 Q 152.9 67.9 154.5 65 Z "
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 69 L 33.5 71 L 34.5 69 Z "
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 69 L 150 71.5 L 149 71.5 L 149.5 69 Z "
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161 72 L 163 72.5 L 163 82.5 L 162 85 L 159 83.5 Q 159.5 79 156 78.5 L 159.5 81 L 161 79.5 L 161 72 Z "
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 74 L 145 75.5 L 143 76.5 L 144.5 74 Z "
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 32.5 75 L 31.5 77 L 32.5 75 Z "
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 78 Q 141.5 79.5 138.5 81 L 138.5 78 Z "
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 83 L 33.5 85 L 34.5 83 Z "
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 17.5 85 L 18.5 87 L 16.5 88 L 17 86.5 L 17.5 85 Z "
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143 87 L 145 87.5 L 143 88.5 L 143 87 Z "
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 87 L 159 90.5 L 157 91.5 Q 159.5 90 156 88.5 L 156.5 87 Z "
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 88 Q 163.3 86.8 162 90.5 L 164 95.5 L 160.5 103 L 159.5 99 L 158 99.5 L 159.5 95 L 160.5 98 L 161 93.5 L 159.5 88 Z "
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 35.5 90 L 36 92 L 34 91.5 L 35.5 90 Z "
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 19.5 94 L 20 97 L 17 96.5 L 19 96 L 19.5 94 Z "
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 31.5 96 Q 34.8 94.9 34 97.5 L 35 99.5 L 34 99.5 L 33.5 98 L 32 98.5 L 32.5 97 L 31.5 96 Z "
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 96 L 158 96.5 L 154.5 99 L 156.5 96 Z "
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 16.5 98 L 19 98.5 L 16.5 102 L 17 100.5 L 16.5 98 Z "
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 102 L 157 104.5 L 158 116.5 Q 157 119 152.5 118 Q 149.8 116.8 152 115.5 L 153 103 L 156.5 102 Z M 154 104 L 154 112 L 156 112 L 156 105 L 154 104 Z "
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 18.5 107 L 20.5 110 L 23 111.5 L 21.5 111 L 19.5 110 L 18 110.5 L 18.5 107 Z "
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 108 L 138.5 109 L 140 108.5 L 139.5 111 L 136.5 108 Z "
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33.5 110 L 36 111.5 L 34 112.5 L 33.5 110 Z "
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 111 L 137.5 113 L 136.5 111 Z "
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 19 114 Q 22 113 21 116 Q 18 117 19 114 Z "
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 114 L 135 119.5 L 133.5 119 L 131.5 120 L 126 118.5 L 128 118 Q 126.3 113.9 130.5 115 L 131.5 114 Z "
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 114 L 135.5 116 L 134 115.5 L 136.5 114 Z "
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 38.5 116 L 39.5 118 L 38.5 116 Z "
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 17 117 L 19 117.5 L 17 118.5 L 17 117 Z "
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 22.5 117 L 22.5 119 Q 25.9 118.1 24 123.5 L 21 121.5 Q 20.3 117.8 22.5 117 Z "
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 50.5 117 L 51.5 119 L 50.5 117 Z "
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 118 L 121.5 120 L 122.5 118 Z "
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 42.5 119 L 42 120.5 L 40.5 123 L 38.5 124 L 39.5 122 Q 41.8 122.8 41 120.5 L 42.5 119 Z "
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 120 Q 150.8 119.3 150 121.5 L 148 122.5 L 148.5 120 Z "
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 122 L 149 127.5 L 148 127.5 L 147.5 126 Q 146.2 128.3 145 125.5 L 145 123.5 L 145.5 122 Z "
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 45.5 124 L 48 125.5 L 46.5 125 L 45.5 124 Z "
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 40.5 125 L 41.5 127 L 40.5 125 Z "
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 125 L 122 126 L 123 128.5 L 119.5 125 Z "
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 54.5 126 L 57 129.5 L 55.5 129 L 53.5 130 L 54.5 126 Z "
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 126 Q 152.8 125.3 152 127.5 Q 153.3 130.3 154.5 128 L 157 128 L 157 133.5 L 156 133.5 L 155.5 131 L 155 136 L 158 137.5 L 159 139.5 L 154.5 142 L 152 141 L 151 135.5 Q 153.5 134 152 128.5 L 150.5 126 Z "
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 25.5 127 L 24.5 129 L 25.5 127 Z "
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102.5 129 L 101.5 131 L 102.5 129 Z "
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 22 131 Q 24.7 129.9 24 132.5 L 21.5 136 L 21 133.5 L 22 131 Z "
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 30.5 134 L 29.5 136 L 30.5 134 Z "
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 134 Q 118.8 132.9 118 135.5 L 120 135.5 Q 118.8 138.3 117.5 136 L 115.5 134 Z "
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 136 L 142 138 L 140 137.5 L 141.5 136 Z "
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 45.5 138 L 46.5 140 L 45.5 138 Z "
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 138 L 146.5 140 L 145.5 138 Z "
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 23.5 139 Q 26.2 140.3 24 141.5 L 23 143.5 L 24 146.5 L 22 145.5 L 20 142.5 L 23.5 139 Z "
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 141 L 106.5 143 L 101.5 144 L 101.5 143 L 107.5 141 Z "
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 141 L 147 143.5 L 147 152 L 143 152 L 144 148.5 L 143.5 146 L 141.5 147 L 142.5 145 L 146 143.5 Q 143.8 142.3 146.5 141 Z "
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 32.5 143 L 32.5 146 L 30 144.5 L 32.5 143 Z "
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 129.5 143 Q 132.5 144.5 129.5 146 L 129.5 143 Z "
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 58.5 145 L 57.5 147 L 58.5 145 Z "
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 146 L 107 148.5 L 105.5 150 L 105 147.5 L 106.5 146 Z "
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 61.5 147 L 63.5 150 L 61.5 147 Z "
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 26.5 148 L 30.5 149 Q 31.7 146.8 33 149.5 L 28.5 150 L 26.5 148 Z "
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 37.5 148 L 38 149.5 L 36 150.5 L 37.5 148 Z "
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 148 L 140 149.5 L 141 153.5 L 139.5 157 L 138 156.5 L 138.5 155 L 128 153.5 L 133.5 153 L 135.5 154 L 135.5 152 L 140 153 L 139 149.5 L 140.5 148 Z "
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 24.5 150 L 27 150.5 L 24.5 151 L 24.5 150 Z "
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 35 152 L 39.5 154 L 42 152.5 Q 41.3 155.8 36.5 155 L 35 152 Z "
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 154 L 128 156.5 L 127.5 158 L 130 159.5 L 128.5 163 L 126 161.5 Q 125.2 158.9 128.5 160 L 128.5 159 L 126 157.5 L 127 155.5 L 126.5 154 Z "
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68.5 155 L 67.5 157 L 68.5 155 Z "
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102 155 L 106 156.5 L 102 157 L 102 155 Z "
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 156 L 135.5 158 L 134.5 156 Z "
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 50.5 158 L 53 159.5 L 51.5 159 L 49.5 160 L 50.5 158 Z "
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 59.5 158 L 60 160 Q 57 158.8 58 162.5 L 56.5 165 L 56 159.5 Q 57.8 161.1 59.5 158 Z "
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 159 L 139 159.5 L 136.5 160 L 136.5 159 Z "
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 63.5 160 L 65 163.5 L 61.5 168 L 61 164.5 L 63.5 160 Z "
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 65.5 161 L 69 161.5 Q 67.8 164.3 66.5 162 L 65.5 161 Z "
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112 161 Q 116.1 159.7 115 163 Q 110.9 164.3 112 161 Z "
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 162 L 85.5 164 L 87 163.5 L 88 165.5 L 86 166.5 Q 86.8 164.3 84.5 165 L 82 166 L 83 163.5 L 82.5 162 Z "
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102.5 162 L 101.5 164 L 102.5 162 Z "
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 162 L 105 163.5 L 104.5 165 L 104 163.5 L 105.5 162 Z "
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 70 164 L 72 164.5 L 70.5 167 L 70 164 Z "
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91 164 L 94 165.5 L 90 166.5 L 91 164 Z "
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 165 L 75 167.5 L 74 167.5 L 73.5 165 Z "
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 66.5 166 L 65.5 168 L 64 167.5 L 66.5 166 Z "
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 166 L 100.5 167 L 102.5 166 L 102.5 167 L 99.5 168 L 97.5 166 Z "
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 12 L 92 12.5 L 81.5 13 L 81.5 12 Z "
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 19 L 102.5 21 L 103.5 19 Z "
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 21 Q 68 23 63.5 25 L 64.5 21 Z "
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 22 L 100 24.5 L 99 24.5 L 99.5 22 Z "
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 24 L 92 26.5 L 91 26.5 L 91.5 24 Z "
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 24 L 126.5 26 L 125.5 24 Z "
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 26 L 80 27.5 L 77 28 L 77.5 26 Z "
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 46.5 28 L 45.5 30 L 46.5 28 Z "
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 51.5 28 L 51 29.5 L 50.5 31 L 50 29.5 L 51.5 28 Z "
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 28 L 131.5 30 L 130.5 28 Z "
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 29 L 131.5 33 L 128.5 29 Z "
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 40.5 30 L 37.5 34 L 40.5 30 Z "
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 54.5 30 L 55.5 32 L 54.5 30 Z "
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 31 L 117.5 33 L 118.5 31 Z "
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 46.5 32 L 45.5 34 L 46.5 32 Z "
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 35 L 131 36.5 L 127 39.5 L 130.5 35 Z "
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 47.5 36 L 48.5 38 L 47.5 36 Z "
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 36 L 123.5 41 L 127.5 36 Z "
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 36 L 137.5 39 L 135.5 36 Z "
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 36 L 139.5 38 L 138.5 36 Z "
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 52.5 37 Q 56 39 51.5 41 L 52.5 37 Z "
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 54.5 40 L 53.5 42 L 54.5 40 Z "
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 129.5 40 L 128.5 42 L 129.5 40 Z "
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 42 L 124.5 46 L 121.5 42 Z "
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 44 L 132.5 46 L 133.5 44 Z "
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 45 L 134.5 47 L 135.5 45 Z "
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 36.5 46 L 37.5 48 L 36.5 46 Z "
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33.5 47 L 32.5 49 L 33.5 47 Z "
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 49 L 136 49.5 Q 136.8 51.8 134.5 51 L 133.5 49 Z "
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 49 L 140 51.5 L 139 51.5 L 138.5 49 Z "
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 40.5 50 L 39.5 52 L 40.5 50 Z "
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 50 L 142 52.5 L 141 52.5 L 141.5 50 Z "
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 57 L 141.5 59 L 142.5 57 Z "
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 27.5 61 L 26.5 63 L 27.5 61 Z "
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 19.5 70 L 20 72.5 L 19 72.5 L 19.5 70 Z "
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 26.5 71 L 30 73.5 L 27.5 72 L 26.5 71 Z "
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33.5 72 L 34 73.5 L 32 74.5 L 33.5 72 Z "
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 23.5 76 L 24 78.5 L 23 78.5 L 23.5 76 Z "
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 29.5 76 L 33 77.5 L 30.5 78 L 29.5 76 Z "
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 35.5 76 L 36 83.5 L 35 83.5 L 35.5 76 Z "
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 76 L 155 85.5 L 154 85.5 L 154.5 76 Z "
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 78 L 153 83.5 L 152 83.5 L 152.5 78 Z "
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 28.5 79 L 31 79.5 L 28.5 80 L 28.5 79 Z "
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 80 L 85.5 82 L 84.5 80 Z "
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 27.5 83 L 31 83.5 L 27.5 84 L 27.5 83 Z "
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 84 L 91.5 86 L 90.5 84 Z "
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 84 L 149 84.5 L 142.5 85 L 142.5 84 Z "
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 30.5 85 L 33 85.5 L 30.5 86 L 30.5 85 Z "
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 91 L 147 92.5 L 145.5 92 L 144.5 91 Z "
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 93 L 86.5 96 L 84.5 93 Z "
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 94 L 89.5 96 L 90.5 94 Z "
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 94 L 148 94.5 L 145.5 96 L 146.5 94 Z "
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 97 L 143.5 99 L 144.5 97 Z "
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 31.5 99 L 32.5 101 L 31.5 99 Z "
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 104 L 92 105.5 L 90 106.5 L 91.5 104 Z "
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89 108 L 91 108.5 L 89 109.5 L 89 108 Z "
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 44.5 109 L 45.5 111 L 44.5 109 Z "
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 111 L 126.5 113 L 127.5 111 Z "
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 47.5 113 L 53.5 120 L 47.5 113 Z "
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 119 L 138.5 121 L 139.5 119 Z "
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 120 L 140.5 122 L 141.5 120 Z "
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 35.5 121 L 36.5 123 L 35.5 121 Z "
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 126 L 131.5 132 L 136.5 126 Z "
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 127 L 131.5 129 L 132.5 127 Z "
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 128 L 141.5 130 L 140.5 128 Z "
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 43.5 129 L 45.5 132 L 43.5 129 Z "
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 131 L 85 131.5 L 81.5 132 L 81.5 131 Z "
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 131 L 92 131.5 L 89.5 132 L 89.5 131 Z "
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33.5 132 L 32.5 134 L 33.5 132 Z "
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 43.5 132 L 44.5 134 L 43.5 132 Z "
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 132 L 125.5 134 L 126.5 132 Z "
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 60.5 133 L 59.5 135 L 60.5 133 Z "
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 133 L 110.5 135 L 109.5 133 Z "
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 133 L 136 135 L 138.5 136 L 139 134 L 137 133.5 L 138.5 133 L 140 135.5 L 136.5 138 L 136 135 Q 132.2 133.5 133 136.5 Q 135.3 137.7 132.5 139 L 130.5 137 L 128 138.5 Q 130 134.8 132 136.5 L 133.5 134 L 135.5 133 Z "
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 134 L 126.5 136 L 127.5 134 Z "
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 36.5 135 L 36 136.5 L 35.5 139 Q 32 137 36.5 135 Z "
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 65.5 136 L 66.5 138 L 65.5 136 Z "
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 69.5 136 L 70 140.5 L 69 140.5 L 68 138.5 L 69.5 136 Z "
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 136 L 92.5 138 L 94 138.5 L 92.5 139 Q 89.5 137.5 92.5 136 Z "
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 136 L 141.5 139 L 143.5 136 Z "
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 28.5 138 L 29.5 140 L 28.5 138 Z "
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 138 L 65.5 140 L 64.5 138 Z "
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75.5 138 L 76.5 142 Q 72 140 75.5 138 Z "
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 138 L 96.5 140 L 97.5 138 Z "
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 139 L 107 140.5 L 105 141.5 L 106.5 139 Z "
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 139 Q 129.3 140.3 127 141.5 L 127.5 143 L 129 142.5 Q 129.8 144.8 127.5 144 L 125.5 141 L 127 140.5 L 126.5 139 Z "
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 140 L 86 140.5 L 82.5 141 L 82.5 140 Z "
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 45.5 142 L 49 145.5 L 48.5 148 Q 46.8 144.9 45 146.5 L 47 144.5 L 45.5 142 Z "
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 142 L 91 144 L 93 144.5 L 91.5 145 L 90.5 142 Z "
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 143 L 35.5 145 L 34.5 143 Z "
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 143 L 122 144.5 L 120.5 145 L 119.5 143 Z "
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 145 L 118 146.5 L 116.5 147 L 115.5 146 L 113 147.5 Q 112.3 145.3 114.5 146 L 115.5 145 Z "
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 53.5 147 L 56 147.5 L 55 148.5 L 58.5 153 L 54 150.5 L 54.5 149 Q 51.7 149.7 53.5 147 Z "
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 147 L 121 147.5 L 116.5 150 L 116.5 149 L 119.5 147 Z "
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 149 L 110.5 151 L 109.5 149 Z "
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 62.5 150 L 62 151.5 L 61.5 154 L 61 151.5 L 62.5 150 Z "
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67 151 L 69 151.5 L 67 152.5 L 67 151 Z "
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 71.5 151 L 70.5 153 L 71.5 151 Z "
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 151 L 100 152.5 L 98.5 155 L 99 153.5 Q 99.8 150.9 96.5 152 L 96.5 151 Z "
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 152 L 64.5 155 Q 61.5 153.5 64.5 152 Z "
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 152 L 85.5 153 L 88.5 152 L 90 152.5 L 90 154.5 L 90.5 156 L 91.5 153 L 93 154.5 L 92.5 157 L 90.5 157 L 89 157 Q 90.5 153.3 87.5 154 L 84.5 153 L 83.5 152 Z "
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 153 L 73.5 156 L 75.5 155 L 79 156.5 L 76.5 157 L 69 155.5 L 72 154.5 L 72.5 153 Z "
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 153 L 104 154.5 L 102.5 154 L 101.5 153 Z "
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 154 L 83 156.5 L 82 156.5 L 82.5 154 Z "
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 159 L 91 159.5 L 80.5 160 L 80.5 159 Z "
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(176,176,171)",
    stroke: "rgb(176,176,171)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 161 L 80 161.5 L 77.5 162 L 77.5 161 Z "
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 9 L 88.5 11 L 87.5 9 Z "
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 10 L 79 11.5 L 78.5 13 L 77.5 11 L 79.5 10 Z "
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 13 L 68.5 15 L 67.5 13 Z "
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 13 L 110.5 14 L 112 13.5 L 108.5 15 L 106.5 13 Z "
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 59.5 14 L 60.5 16 L 59.5 14 Z "
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 63.5 14 L 66 14.5 L 63.5 15 L 63.5 14 Z "
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 15 L 79 16.5 L 78.5 20 L 78 16.5 L 79.5 15 Z "
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 15 Q 120.9 13.5 120 16.5 L 115 18.5 L 116.5 15 Z "
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75.5 16 L 74.5 18 L 75.5 16 Z "
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 16 L 85.5 17 L 87 16.5 L 85.5 19 L 83.5 16 Z "
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 16 L 98.5 18 L 97 17.5 Q 97.7 20.1 95 19 Q 93.9 16.3 96.5 17 L 97.5 16 Z "
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 16 Q 102.8 15.3 102 17.5 L 100.5 16 Z "
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 18 L 106.5 20 L 105 19.5 L 107.5 18 Z "
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 49.5 19 L 51.5 20 L 53 19.5 L 50 21.5 L 50.5 23 L 48 22 L 49.5 19 Z "
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 19 L 125 20.5 L 124.5 22 L 123.5 20 Q 121.7 22.5 121.5 19 Z "
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 20 L 88 22.5 L 86 21.5 L 86.5 20 Z "
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 20 L 92 22.5 L 90 23 L 90.5 20 Z "
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 20 L 96.5 22 L 97.5 20 Z "
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 20 L 112 21.5 L 111.5 23 L 109 21.5 L 112.5 20 Z "
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 22 L 119 24.5 L 117.5 25 Q 115.8 21.9 114 23.5 L 115.5 22 Z "
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 23 L 77.5 25 L 76 24.5 L 78.5 23 Z "
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 55.5 24 L 57.5 27 Q 58.8 24.8 60 27.5 Q 59.3 29.8 61.5 29 L 63 28.5 L 58.5 32 L 58.5 30 L 55 28.5 L 56 25.5 L 54 25.5 L 55.5 24 Z "
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 65 24 L 67 24.5 Q 64.5 26 68 27.5 L 67.5 29 L 65 24 Z "
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 43.5 25 L 46 25.5 L 43.5 26 L 43.5 25 Z "
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 51.5 25 L 54 28.5 L 53 28.5 L 52.5 27 L 49.5 29 L 48.5 27 L 50.5 27 L 52 26.5 L 51.5 25 Z "
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 25 Q 118.5 26.5 115.5 28 Q 113.3 28.8 114 26.5 L 115.5 25 Z "
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 129.5 25 Q 131.8 24.3 131 26.5 L 129.5 25 Z "
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 25 L 135 26.5 L 136 28.5 Q 133.3 30.2 137.5 32 L 139.5 33 Q 140.8 30.7 142 33.5 L 139 34.5 L 143 37.5 L 141.5 37 L 138 34.5 L 136.5 32 L 135 32.5 Q 137.8 30.8 133.5 29 L 132 28.5 L 134 27.5 L 132.5 25 Z "
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 26 L 83.5 28 L 85.5 27 L 86.5 29 L 80 27.5 L 82.5 26 Z "
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 27 L 74.5 29 Q 71.7 29.7 73.5 27 Z "
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 27 L 92 27.5 L 88.5 29 L 89.5 27 Z "
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 27 L 96 28.5 L 94.5 28 L 93.5 27 Z "
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 28 L 127.5 30 L 126.5 28 Z "
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102.5 29 L 104 29.5 L 101.5 31 L 102.5 29 Z "
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 29 L 120 29.5 Q 117.9 32.8 117.5 29 Z "
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 29 L 126 31.5 L 124.5 31 L 123 30.5 L 124.5 29 Z "
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 37.5 30 L 39 30.5 L 36.5 32 L 37.5 30 Z "
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 44.5 30 L 44.5 33 Q 41.5 31.5 44.5 30 Z "
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 30 L 69 30.5 L 66.5 32 L 67.5 30 Z "
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48.5 31 L 49.5 33 L 48.5 31 Z "
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 31 Q 130.1 30.2 129 33.5 L 128 33.5 L 127.5 31 Z "
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122 32 L 127 33 L 126.5 35 L 123.5 33 L 123 34.5 L 123.5 37 L 125 37.5 L 122 38 L 121.5 41 L 119.5 41 L 117 38.5 L 122 37.5 L 121.5 36 L 123 35.5 L 122 32 Z "
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 44.5 34 L 47 35.5 L 45.5 35 L 44.5 34 Z "
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 31.5 36 L 33.5 37 L 35 36.5 L 32 37.5 L 31.5 39 Q 28.5 37.5 31.5 36 Z "
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57.5 37 L 56.5 39 L 57.5 37 Z "
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 38.5 38 L 40 38.5 L 37.5 40 L 38.5 38 Z "
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 46.5 38 L 47.5 40 L 46.5 38 Z "
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 38 L 136.5 40 Q 137.7 37.8 139 40.5 L 137 40.5 L 136.5 42 L 136 40 L 134 39.5 L 135.5 38 Z "
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 28.5 40 L 29 42.5 L 28.5 45 L 27 44.5 L 26 47.5 L 26.5 49 L 25 48.5 L 24.5 50 L 24 48.5 L 25 46.5 L 24.5 45 L 26 45.5 L 26 43 Q 29.1 44.1 28.5 40 Z "
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 41 L 36.5 41 L 39 42.5 L 37.5 42 L 34.5 44 Q 31.5 42.5 34.5 41 Z "
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 43 L 148 45.5 L 146 44.5 L 146.5 43 Z "
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 39.5 44 L 41 44.5 L 37.5 46 L 37.5 45 L 39.5 44 Z "
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139 45 Q 142 44 141 47 Q 138 48 139 45 Z "
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 40 46 L 42 46.5 L 41.5 49 L 40 46 Z "
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 47 L 129 49 L 127 48.5 L 128.5 47 Z "
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 48 Q 150.3 51.1 152 49.5 L 151.5 54 L 149 53.5 L 150 50.5 L 148.5 48 Z "
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 30.5 50 Q 33.1 49.2 32 52.5 L 31 52.5 L 30.5 50 Z "
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 22.5 52 L 24 54.5 L 22 54.5 L 23 57.5 Q 19.9 59.3 21.5 61 L 20 60.5 L 19.5 63 Q 16.3 61.3 20 59.5 Q 19.3 57.3 21.5 58 L 21.5 57 L 19 55.5 L 21 55.5 L 22.5 52 Z "
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33 52 L 36 53.5 L 35.5 56 Q 33.3 56.8 34 54.5 L 32 54.5 L 33 52 Z "
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 52 L 146 52.5 L 143 54.5 L 143.5 52 Z "
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 42.5 53 L 42 54.5 L 41.5 56 L 41 54.5 L 42.5 53 Z "
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 29.5 54 L 28.5 56 L 29.5 54 Z "
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 56 L 138 59.5 L 137 59.5 L 137.5 56 Z "
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 57 L 136 58.5 Q 134.5 61.5 133 58.5 L 135 58.5 L 135.5 57 Z "
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 26.5 58 L 27 60 L 31 60.5 L 25.5 62 L 25 60.5 L 26.5 58 Z "
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 37.5 60 Q 40.5 61.5 37.5 63 L 36 62.5 L 37.5 60 Z "
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 62 L 145 63.5 L 143.5 63 L 142.5 62 Z "
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 64 L 137.5 67 Q 135.3 67.8 136 65.5 L 137.5 64 Z "
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 64 L 156 65.5 L 155.5 67 L 155 65.5 L 156.5 64 Z "
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 35.5 65 L 37 66.5 L 36 69.5 L 34.5 72 L 34 70.5 L 36 68.5 L 35.5 65 Z "
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 65 L 150 66.5 L 148.5 67 L 147.5 65 Z "
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 67 L 144.5 69 L 143 68.5 L 145.5 67 Z "
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 24.5 69 L 24.5 72 Q 21.5 70.5 24.5 69 Z "
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137 69 L 139.5 70 L 141.5 69 L 142.5 71 L 140.5 70 Q 138.8 73.8 137 70.5 L 137 69 Z "
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 70 Q 153.5 71.5 150.5 73 L 150.5 70 Z "
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138 74 L 141 75.5 L 140.5 78 Q 138.3 78.8 139 76.5 L 138 74 Z "
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33.5 75 L 34 78.5 L 33 78.5 L 32 76.5 L 33.5 75 Z "
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 22.5 79 L 25 79.5 L 22.5 80 L 22.5 79 Z "
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144 79 Q 148.7 78 150 81.5 L 149.5 83 L 147.5 80 L 144.5 81 L 144 79 Z "
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 32.5 80 L 33.5 82 L 32.5 80 Z "
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 83 L 141.5 87 L 139.5 88 L 138.5 83 Z "
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 29.5 86 Q 32.3 87.3 30 88.5 Q 30.9 91.5 26.5 90 L 26.5 89 Q 30.5 90.1 29.5 86 Z "
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 86 L 150 87.5 L 150.5 89 L 152 88.5 Q 152.8 90.8 150.5 90 L 149 87 L 147.5 86 Z "
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 88 L 157 90.5 L 155 89.5 L 155.5 88 Z "
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 89 L 137.5 91 L 138.5 89 Z "
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 23.5 90 L 22.5 92 L 23.5 90 Z "
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 31.5 92 L 30.5 94 L 31.5 92 Z "
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 94 L 136.5 96 L 137.5 94 Z "
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 94 L 156 95.5 L 154.5 98 L 153 95.5 L 155.5 94 Z "
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 37.5 96 L 38 97.5 L 37.5 100 L 34.5 101 L 32 99.5 L 32.5 97 L 34.5 97 L 36.5 98 L 37.5 96 Z "
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 24.5 99 L 25.5 101 L 24.5 99 Z "
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 99 L 86 99.5 L 82.5 101 L 82.5 100 L 84.5 99 Z "
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 100 L 137 101.5 L 135 107.5 L 137 113.5 L 132.5 114 L 130.5 113 L 126.5 116 L 126.5 113 L 128 113.5 Q 127.2 110.9 130.5 112 L 131.5 110 L 130 109.5 L 132 106 L 134 105.5 L 132 104.5 L 134 103.5 L 133.5 102 Q 134.8 104.3 136 101.5 L 134.5 100 Z M 134 107 L 134 111 L 135 111 L 134 107 Z "
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 102 L 147 103.5 L 144 105 L 144.5 107 L 146 106.5 L 145.5 109 L 144 108.5 L 145 110.5 L 143 109.5 L 144 107.5 L 142.5 105 L 146 104 L 146.5 102 Z "
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 38.5 103 L 41 103.5 L 38 104.5 L 41 105.5 Q 38.8 106.8 41.5 108 L 43 107.5 Q 40.3 109.3 44.5 111 Q 47.1 110.2 46 113.5 L 51 120 L 56 121.5 L 55.5 123 L 60 124.5 L 59 127.5 Q 60.1 130.8 57.5 130 L 58 126.5 L 57.5 125 Q 56.3 127.3 55 124.5 Q 55.7 121.9 53 123 L 52.5 125 L 50.5 125 L 48.5 124 L 47 124.5 L 49 121.5 L 47.5 119 Q 50.1 119.7 49 117 L 45.5 118 L 45.5 117 L 47 116.5 L 43.5 113 L 42.5 114 L 38.5 113 L 38.5 115 L 36.5 112 Q 37.8 114.3 39 111.5 Q 40.3 107.3 35.5 109 L 35.5 107 L 33 105.5 L 34.5 106 L 37.5 104 L 38.5 103 Z M 41 108 L 40 110 L 42 111 L 41 108 Z "
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93 104 Q 96 103 95 106 Q 92 107 93 104 Z "
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150 108 L 152 108.5 L 149 112.5 L 149.5 114 L 147.5 115 L 147 113.5 L 147.5 111 L 149 111.5 L 148 109.5 L 150 109.5 L 150 108 Z "
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33.5 111 L 35 114.5 L 34.5 117 L 32 116.5 L 34 113.5 L 32 113.5 L 33.5 111 Z "
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 111 L 143.5 113 L 142.5 111 Z "
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 23.5 112 L 25.5 113 L 27 112.5 L 24.5 114 L 23.5 112 Z "
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 114 L 140.5 116 L 139.5 114 Z "
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 115 Q 140.5 116.5 137.5 118 L 137.5 115 Z "
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 29.5 117 L 28.5 119 L 29.5 117 Z "
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 117 L 126 118.5 L 125 119.5 L 125 126 L 122 124.5 Q 122.8 122.3 120.5 123 L 123 119.5 L 122.5 117 Z M 124 120 L 122 123 L 124 122 L 124 120 Z "
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 117 L 150.5 119 L 151.5 117 Z "
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 119 L 137 121 L 135 120.5 L 136.5 119 Z "
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 38.5 120 L 41 121.5 L 37.5 122 L 38.5 120 Z "
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 120 L 141.5 122 L 142.5 120 Z "
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 30.5 121 Q 33.3 122.2 31 123.5 L 30.5 125 L 30.5 121 Z "
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 121 L 133.5 123 L 135 122.5 Q 129.6 125.3 131.5 128 Q 130.3 125.8 129 128.5 L 129.5 130 L 127.5 129 L 125.5 132 L 124 131.5 L 126 131 L 127.5 128 L 130 126.5 Q 129.3 124.3 131.5 125 L 132.5 123 L 131 122.5 L 132.5 121 Z "
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 122 L 120 124.5 L 116 125.5 L 115 123.5 L 116.5 124 Q 119 124.7 118.5 122 Z "
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 28.5 125 L 29 127.5 L 26 129.5 L 28.5 125 Z "
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114.5 125 L 115 126.5 L 114 129.5 L 113.5 135 Q 111.8 131.9 110 133.5 L 109 131.5 L 111 131 Q 110 127.2 112.5 126 L 114 126.5 L 114.5 125 Z "
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 125 L 146 128.5 L 145.5 130 L 147.5 129 L 147.5 131 Q 150.1 130.2 149 133.5 L 150 133.5 L 150.5 132 L 151 133.5 L 148 135.5 L 148 133.5 Q 148.8 131.3 146.5 132 L 143 126.5 L 144.5 125 Z "
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 42.5 126 Q 44.8 125.3 44 127.5 L 45 127.5 L 45.5 126 L 47 129.5 L 45.5 130 Q 43.8 126.9 42 128.5 L 42.5 126 Z "
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 63.5 126 L 64.5 128 L 66 127.5 L 65.5 129 L 67.5 128 L 66.5 130 Q 63.2 131.1 64 128.5 L 61 127.5 L 63.5 126 Z "
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 126 L 140 127.5 L 139.5 130 L 137.5 129 L 137 130.5 L 140 131.5 L 139.5 134 L 136 129.5 L 138.5 126 Z "
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 35.5 128 L 37.5 129 L 39 128.5 L 39 130.5 L 37.5 133 L 38 131.5 L 35.5 128 Z "
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 128 L 106.5 130 L 105.5 128 Z "
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108 128 Q 111 127 110 130 Q 107 131 108 128 Z "
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33.5 129 L 35 131.5 L 33 130.5 L 33.5 129 Z "
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 130 L 74 132 L 80 131 L 82 134.5 L 80.5 134 L 78.5 135 L 78.5 133 L 73.5 134 L 71 132.5 L 73 132 L 73.5 130 Z "
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 130 L 103 130.5 L 103 132.5 L 102.5 135 L 100.5 130 Z "
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48.5 131 Q 50.8 130.3 50 132.5 L 47 132.5 L 48.5 131 Z "
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 54.5 131 L 57 131.5 L 56 133.5 L 56.5 135 Q 52.5 135.5 52 132.5 L 53.5 133 L 55 132.5 L 54.5 131 Z "
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 131 L 122.5 134 L 121 134.5 L 121.5 136 Q 118.8 134.8 121 133.5 L 122.5 131 Z "
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 131 L 134 133.5 L 132 132.5 L 133.5 131 Z "
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 25.5 132 L 26 134.5 L 24 133.5 L 25.5 132 Z "
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 40.5 132 L 41.5 134 L 40 134.5 L 40.5 136 L 38.5 136 Q 36.3 136.8 37 134.5 L 40 133.5 L 40.5 132 Z "
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 95 132 L 97 132.5 L 95 133.5 L 95 132 Z "
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 133 L 91 134.5 L 89.5 135 L 87.5 133 Z "
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 43.5 134 L 44 136 L 46 136.5 L 43.5 138 L 42 135.5 L 43.5 134 Z "
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 134 L 132 134.5 L 125.5 138 L 125.5 137 L 130.5 134 Z "
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 134 L 143 136 L 140 137.5 L 140.5 139 L 137 138.5 L 142.5 134 Z "
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 59.5 135 L 61 136.5 L 60.5 139 L 58 137.5 L 60 136.5 L 59.5 135 Z "
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 137 Q 88.8 135.9 88 138.5 L 86.5 138 L 85.5 137 Z "
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 47 138 L 49 138 Q 47.5 141.8 50.5 141 L 52 140.5 Q 49.2 142.3 53.5 144 L 55 143.5 L 54.5 145 L 57.5 144 L 58 146 L 54.5 146 L 47 139.5 L 47 138 Z "
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 138 L 117 138.5 L 114.5 140 L 115.5 138 Z "
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 27.5 139 L 28.5 141 L 27.5 139 Z "
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 139 L 111 139.5 L 109.5 142 L 107.5 141 L 106 141.5 L 109.5 139 Z "
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122 139 L 124 139.5 L 122 140.5 L 122 139 Z "
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 139 L 148 141.5 Q 146.8 144.3 145.5 142 L 144 141.5 L 144.5 139 Z "
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 140 L 118.5 143 L 117.5 141 Q 119 143.5 120.5 140 Z "
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 26.5 141 L 27.5 143 L 26.5 141 Z "
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 141 L 135 141.5 L 132 143.5 L 132.5 145 Q 129.8 143.8 132 142.5 L 132.5 141 Z "
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 30.5 143 L 34 144.5 L 29.5 146 L 29.5 145 L 32 144.5 L 30.5 143 Z "
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 60.5 143 L 60.5 145 Q 62.8 144.3 62 146.5 L 65 147.5 L 64.5 150 L 63.5 147 L 62.5 148 L 59 144.5 L 60.5 143 Z "
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 43.5 144 L 44 145.5 Q 42.5 148.5 41 145.5 L 43 145.5 L 43.5 144 Z "
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 49.5 144 L 52 145.5 Q 52.8 147.8 50.5 147 L 50.5 145 L 49.5 144 Z "
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 144 L 93 145.5 L 90 146 L 90.5 144 Z "
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110.5 144 L 113 145.5 L 110.5 148 L 107 146.5 L 109.5 146 L 111 145.5 L 110.5 144 Z "
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 144 L 130 144.5 L 127.5 146 L 128.5 144 Z "
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 144 L 140 146.5 Q 140.7 149.1 138 148 L 139.5 144 Z "
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33.5 146 L 36 146.5 Q 33.9 149.8 33.5 146 Z "
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 146 L 124.5 148 L 123.5 146 Z "
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 147 L 70 148.5 L 69.5 151 L 67.5 147 Z "
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 147 L 72.5 149 L 71 148.5 L 73.5 147 Z "
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 147 L 106 148.5 L 103.5 150 L 100.5 148 L 99 148.5 L 100.5 147 Z "
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 148 L 83 148.5 L 78.5 150 L 78.5 149 L 81.5 148 Z "
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 148 L 92 148.5 L 90 149.5 L 90.5 151 L 88 150.5 L 90.5 148 Z "
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 39.5 149 Q 42.5 150.5 39.5 152 L 39.5 149 Z "
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 149 L 97 149.5 L 93.5 150 L 93.5 149 Z "
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 149 L 120.5 151 L 121.5 149 Z "
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 149 L 132.5 150 L 134.5 150 L 136 150.5 Q 135.5 153.5 131.5 153 L 130 151.5 L 130.5 149 Z "
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 43.5 150 L 43 151.5 L 42.5 153 L 42 151.5 L 43.5 150 Z "
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 150 Q 77.9 148.1 77 151.5 L 77.5 153 L 76 152.5 L 75.5 154 L 75 152.5 L 75.5 151 Q 71.5 151.8 72.5 150 Z "
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 150 L 84 150.5 L 81.5 152 L 82.5 150 Z "
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 151 L 80 153.5 L 79 153.5 L 79.5 151 Z "
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 151 L 94.5 153 L 93.5 151 Z "
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114 151 L 116 151.5 L 114 152.5 L 114 151 Z "
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 46.5 152 L 46.5 155 L 44 153.5 L 46.5 152 Z "
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 59.5 152 L 58.5 154 L 59.5 152 Z "
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 152 L 107.5 155 L 105.5 152 Z "
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 62.5 153 L 64 155.5 L 61 155.5 L 62.5 153 Z "
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 49.5 155 L 55 158.5 L 53.5 158 L 51.5 157 L 49.5 157 L 47 156.5 L 49.5 155 Z "
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 155 Q 96.5 156.5 93.5 158 L 93.5 155 Z "
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 155 L 121 156.5 Q 121.8 158.8 119.5 158 L 121.5 155 Z "
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123 155 L 125 155.5 L 124 157.5 L 126 157.5 Q 126.8 159.8 124.5 159 L 123 155 Z "
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68.5 156 L 70.5 156 L 72 156.5 L 69.5 158 L 68.5 156 Z "
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 156 L 97 157.5 L 96.5 159 L 96 157.5 L 97.5 156 Z "
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 156 L 114.5 158 L 115.5 156 Z "
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 58.5 157 L 57.5 159 L 58.5 157 Z "
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 157 L 116.5 159 L 117.5 157 Z "
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73 161 L 75 161.5 L 73 162.5 L 73 161 Z "
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 95.5 161 L 98 162.5 L 96.5 163 L 95.5 161 Z "
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 161 L 109 161.5 L 103.5 162 L 103.5 161 Z "
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(247,248,247)",
    stroke: "rgb(247,248,247)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68.5 162 L 71 162.5 L 68.5 163 L 68.5 162 Z "
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 0 0 L 168 0 L 168 171 L 0 171 L 0 0 Z M 75 3 Q 72 4 72 8 L 75 9 L 73 12 Q 75 13 73 14 L 67 13 L 67 15 L 64 14 L 66 13 L 64 11 Q 61 10 62 13 L 59 14 L 60 17 L 56 20 L 53 19 L 53 18 L 51 16 L 51 18 Q 50 20 49 18 Q 44 22 42 28 L 39 29 L 41 29 L 41 30 L 39 29 Q 34 31 37 33 L 34 34 L 34 32 L 33 36 L 35 36 L 31 42 L 28 44 L 32 38 Q 34 36 32 35 L 27 39 L 28 41 L 25 41 L 22 49 L 25 47 L 24 49 L 25 51 L 24 54 L 22 55 L 23 53 L 21 53 L 22 51 L 22 49 Q 19 50 20 54 L 17 55 L 19 55 L 20 59 L 16 65 L 18 66 L 22 59 L 21 61 Q 22 65 19 64 L 20 67 L 18 70 L 19 73 L 19 75 L 16 76 L 19 77 L 16 78 L 19 80 L 18 84 L 19 86 L 18 85 L 17 87 L 19 91 L 18 93 L 20 94 L 17 95 L 18 99 L 16 99 L 18 102 Q 17 105 20 104 L 22 108 L 19 105 L 17 110 L 17 112 Q 16 114 20 113 L 19 112 L 21 112 Q 23 111 22 114 L 25 115 L 24 117 L 26 116 Q 24 118 27 120 L 26 123 L 28 126 L 25 125 L 24 128 Q 25 132 22 131 L 21 136 Q 26 135 27 138 L 26 138 L 24 138 Q 23 140 27 139 L 29 139 L 30 141 L 30 145 L 27 145 L 28 143 L 25 144 Q 24 141 27 142 Q 28 139 25 140 L 24 139 L 20 143 L 22 146 Q 23 148 25 146 L 29 147 L 33 146 L 35 149 Q 37 148 36 151 L 38 151 L 35 152 L 37 155 Q 41 156 42 153 L 41 155 L 43 155 L 45 157 L 43 154 L 45 151 L 52 156 L 51 155 L 42 159 L 44 159 L 47 160 L 49 159 L 51 160 L 53 160 L 53 159 L 55 159 Q 54 156 57 157 L 55 160 L 57 165 L 58 161 Q 56 159 59 158 L 58 160 L 60 160 L 62 160 L 64 159 L 65 162 L 67 163 L 66 163 L 64 160 Q 60 163 61 168 L 69 168 L 64 166 L 68 164 L 70 165 L 67 166 L 72 167 L 72 165 L 74 166 L 75 168 L 77 164 L 79 168 L 79 166 L 83 167 L 81 167 L 81 168 L 89 168 L 88 167 L 89 165 L 90 168 L 93 167 L 95 168 L 95 167 Q 97 162 99 165 Q 102 164 101 167 Q 104 168 103 166 L 105 166 L 112 166 L 109 165 L 112 164 L 110 163 L 110 162 L 113 163 Q 116 164 115 161 Q 110 162 107 160 Q 111 160 113 157 L 115 158 L 119 156 L 120 156 L 116 159 L 118 159 L 121 158 Q 120 155 123 156 L 120 160 L 122 160 L 125 159 L 126 162 L 129 163 L 130 160 L 128 158 L 128 160 L 126 159 L 128 156 L 126 157 L 124 157 L 126 156 L 125 155 L 123 155 L 124 153 L 127 155 L 135 153 L 136 154 L 134 154 L 136 158 L 140 157 Q 142 156 140 155 L 143 151 L 147 152 L 147 145 Q 150 143 149 139 L 151 139 L 148 138 L 146 139 L 151 136 L 152 139 Q 149 140 150 144 L 152 144 L 151 141 L 155 142 L 159 140 L 157 137 L 157 129 L 155 128 L 153 128 L 149 131 L 147 131 L 149 130 Q 150 126 147 125 L 149 123 L 151 125 L 151 119 L 149 118 L 149 117 L 149 115 L 151 116 L 150 115 L 152 116 L 151 118 Q 156 119 158 117 Q 156 111 157 103 L 156 103 L 155 101 L 154 103 L 152 103 L 154 100 L 152 100 L 154 97 L 155 101 L 159 103 L 159 102 L 159 100 L 161 103 L 164 96 L 162 88 L 160 87 L 159 89 L 160 90 L 158 87 Q 161 85 157 84 L 158 82 L 158 84 L 162 85 L 163 83 L 163 73 L 160 72 Q 158 75 156 71 L 158 71 L 159 67 L 160 70 L 163 66 L 162 61 L 160 62 L 157 61 L 157 64 L 154 61 Q 155 58 153 59 L 152 57 L 154 58 Q 157 57 155 61 L 157 61 L 156 60 Q 157 56 154 57 L 153 52 L 154 48 L 152 44 L 150 45 L 151 47 L 150 46 L 148 49 Q 150 47 152 51 L 150 51 L 151 54 L 151 55 L 146 47 L 148 46 L 150 43 L 148 44 L 148 43 L 146 41 L 143 42 L 142 39 L 143 36 L 143 34 L 141 27 L 136 30 L 135 28 L 137 28 L 140 26 Q 141 22 136 24 L 136 21 L 134 25 L 133 24 L 128 25 Q 125 26 126 24 L 125 23 L 128 20 L 127 18 L 126 20 L 125 18 L 122 22 L 121 20 Q 123 21 122 18 L 124 18 Q 122 14 121 18 L 119 18 L 121 17 Q 124 15 120 13 Q 113 12 111 16 L 108 16 L 111 15 L 107 13 L 105 13 L 103 14 L 100 13 L 98 13 L 96 12 L 95 10 L 97 11 L 95 9 L 98 10 Q 97 7 100 8 L 99 10 L 100 12 L 103 12 L 101 11 L 102 8 L 101 3 L 96 3 L 96 5 L 88 8 L 90 9 L 88 9 L 86 9 L 83 8 L 80 9 Q 77 8 78 5 L 75 3 Z M 108 8 L 105 9 Q 103 13 107 12 L 106 11 L 108 10 L 108 8 Z M 110 8 L 110 10 L 112 9 L 110 8 Z M 103 9 L 104 11 Q 105 8 103 9 Z M 58 11 L 58 12 L 60 12 L 58 11 Z M 55 16 L 54 18 Q 56 21 57 18 L 55 16 Z M 41 18 L 40 20 L 43 21 L 44 21 L 41 18 Z M 40 22 L 40 24 L 40 26 L 42 26 Q 44 25 42 24 Q 43 21 40 22 Z M 34 25 L 35 27 L 36 27 L 34 25 Z M 36 27 L 37 29 L 39 28 L 36 27 Z M 144 27 L 143 30 L 144 30 L 144 27 Z M 27 32 L 27 36 L 29 36 L 30 34 L 27 32 Z M 25 35 L 25 40 L 25 38 Q 27 36 25 35 Z M 19 48 L 17 49 L 17 50 Q 19 49 18 52 L 19 52 L 19 48 Z M 157 48 L 155 56 L 157 57 L 157 48 Z M 18 56 L 17 59 L 19 59 L 18 56 Z M 159 56 L 157 58 L 158 60 L 159 58 L 159 56 Z M 17 89 L 16 92 L 17 92 L 17 89 Z M 19 114 Q 18 117 21 116 Q 22 113 19 114 Z M 17 117 Q 16 120 19 119 Q 20 116 17 117 Z M 23 117 L 21 119 Q 20 123 24 124 L 26 124 L 24 123 L 26 122 L 26 119 L 25 121 L 24 121 L 25 119 L 23 117 Z M 151 126 L 152 128 Q 153 125 151 126 Z M 27 148 L 28 150 L 24 151 L 33 152 L 32 151 L 34 151 L 35 151 Q 34 147 27 148 Z M 45 152 Q 43 155 46 154 L 45 152 Z M 41 156 L 41 157 L 43 157 L 41 156 Z M 112 158 L 112 160 L 114 159 L 112 158 Z M 137 159 L 137 160 L 139 160 L 137 159 Z "
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 9 L 76 10.5 L 77 12.5 L 75 11.5 L 76.5 9 Z "
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 10 L 85.5 12 Q 82.7 12.7 84.5 10 Z "
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 10 L 93 10.5 L 87.5 12 L 87.5 11 L 90.5 10 Z "
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 15 L 89 15.5 Q 89.8 17.8 87.5 17 L 85.5 17 Q 82.7 17.7 84.5 15 Z "
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91 15 Q 94 14 93 17 Q 90 18 91 15 Z "
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 16 L 101.5 18 L 105 17.5 Q 105.8 20.1 102.5 19 L 101 22.5 L 100.5 24 L 100 22.5 L 101 19.5 L 98.5 17 L 97 17.5 L 98.5 16 Z "
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 69.5 17 L 72.5 18 L 73.5 17 L 76.5 20 Q 79.8 21.1 79 18.5 L 80 18.5 L 79 23 L 76 21.5 L 73.5 18 L 68.5 20 L 67.5 18 L 69.5 17 Z "
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 18 L 87.5 20 Q 84.7 20.7 86.5 18 Z "
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 18 L 109 19 L 108.5 21 L 107.5 20 L 105 21.5 Q 104.3 19.3 106.5 20 L 106.5 18 Z "
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 52.5 20 L 51.5 22 L 45.5 25 L 46.5 23 L 52.5 20 Z "
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 61.5 20 L 65 20.5 L 61 21 L 60.5 23 L 59.5 21 L 61.5 20 Z "
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 21 L 117 24.5 L 115 25 Q 116.1 22.3 113.5 23 L 112.5 21 Z "
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110.5 22 Q 113.5 23.5 110.5 25 L 110.5 22 Z "
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 24 L 96 26.5 L 94 25.5 L 94.5 24 Z "
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 25 L 122 27.5 L 120 26.5 L 120.5 25 Z "
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 44.5 26 L 43.5 28 L 44.5 26 Z "
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 51.5 26 L 52.5 28 L 51.5 26 Z "
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 26 L 68.5 28 L 67.5 26 Z "
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 26 L 73 28.5 L 72 28.5 L 72.5 26 Z "
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56.5 27 L 57.5 29 L 56.5 27 Z "
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 27 L 125 28.5 L 123 29.5 L 124.5 27 Z "
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 28 L 112.5 30 L 113.5 28 Z "
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 54.5 29 L 58 30.5 L 55.5 31 L 54.5 29 Z "
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68.5 29 L 71 30.5 L 69.5 31 L 68.5 29 Z "
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 29 L 102.5 31 L 101.5 29 Z "
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 29 L 117.5 31 L 118.5 29 Z "
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 29 L 136 31.5 L 134.5 32 L 132.5 29 Z "
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 45.5 30 L 48 30.5 L 44 32.5 L 44 34.5 Q 43.3 36.8 45.5 36 L 49 38.5 L 50 40.5 L 46.5 38 L 43 35.5 L 42 33.5 L 45.5 30 Z "
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 49.5 31 L 50.5 33 L 49.5 31 Z "
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 31 L 121.5 33 L 120.5 31 Z "
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 60.5 32 L 62 34.5 L 60 33.5 L 60.5 32 Z "
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 32 L 63.5 34 L 64.5 32 Z "
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 129.5 32 L 133 34.5 L 132 36.5 L 132.5 38 Q 129.8 36.8 132 35.5 Q 132.8 33.3 130.5 34 L 129.5 32 Z "
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 33 Q 138.8 37.3 141 35.5 L 139.5 37 L 136.5 33 Z "
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 34 Q 114.8 32.9 114 35.5 L 112.5 35 L 111.5 34 Z "
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 34 L 127.5 36 L 126 35.5 L 128.5 34 Z "
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 39.5 35 L 42 35.5 L 40.5 38 L 39.5 35 Z "
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 36 L 135.5 38 L 134.5 36 Z "
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 37.5 38 L 37.5 41 L 35 40.5 L 37.5 38 Z "
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 52.5 38 L 54.5 39 L 56 38.5 L 53 40.5 L 52.5 38 Z "
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 38 L 129.5 40 L 130.5 38 Z "
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 39.5 39 Q 42.8 37.9 42 40.5 L 44 40.5 Q 42.3 43.8 40.5 40 L 39.5 39 Z "
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122 39 L 124 39.5 L 122 40.5 L 122 39 Z "
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 127.5 40 L 128 42 L 125.5 43 L 127.5 40 Z "
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 41 L 134.5 43 L 135.5 41 Z "
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 41 L 138.5 43 L 137.5 41 Z "
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33.5 43 L 34.5 45 L 33 44.5 L 32.5 46 L 32 44.5 L 33.5 43 Z "
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 38.5 43 L 39 45 L 43 46.5 L 40 48.5 L 41.5 46 L 38 44.5 L 38.5 43 Z "
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 43 Q 146.8 42.3 146 44.5 L 144.5 43 Z "
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 129.5 44 L 129 45.5 L 127.5 48 L 126.5 46 L 128 46.5 L 129.5 44 Z "
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 46 L 141.5 49 Q 138.5 47.5 141.5 46 Z "
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 31 47 L 33 47.5 L 30 49.5 L 31 47 Z "
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 47 L 135 49.5 L 133 48.5 L 134.5 47 Z "
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 48 L 144 49.5 L 143 50.5 L 146 53.5 L 147 55.5 L 144 55.5 L 145 53.5 L 143 52.5 L 141 55.5 L 142 58 L 138.5 59 L 138.5 56 L 140.5 57 L 139.5 54 Q 140.8 56.3 142 53.5 L 143.5 48 Z "
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 44.5 49 L 43.5 51 L 44.5 49 Z "
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 50 L 131 51.5 L 132 53.5 L 130 52.5 L 131.5 50 Z "
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 28.5 51 L 31 51.5 L 31.5 53 L 33 52.5 L 30 54.5 L 30.5 53 L 28.5 54 L 28.5 51 Z "
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 51 L 38 53.5 L 36.5 56 L 35.5 53 L 34 53.5 L 34.5 51 Z "
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 40.5 55 L 41 56.5 L 39 57.5 L 40.5 55 Z "
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 22.5 56 L 21.5 58 L 22.5 56 Z "
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 26.5 56 L 30 58 L 29.5 60 L 27 59.5 L 28 58.5 L 26.5 56 Z "
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 57 L 134.5 59 L 133.5 57 Z "
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145 57 L 148 57.5 L 145 59 L 145 57 Z "
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 59 L 148 60.5 L 147 62.5 L 150 63.5 L 149.5 66 L 146 62.5 L 146.5 60 L 148.5 59 Z "
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 60 L 155 64.5 L 153 63.5 L 152.5 60 Z "
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 61 L 37 65.5 L 35 64.5 L 34.5 61 Z "
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 62 L 141 63.5 L 139 64.5 L 140.5 62 Z "
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 24.5 63 L 25 65 L 23 64.5 L 24.5 63 Z "
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 63 L 159 65.5 L 158 65.5 L 158.5 63 Z "
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 65 L 157 67.5 L 154 69 L 154.5 67 L 156 67.5 L 156.5 65 Z "
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 23.5 66 Q 26.2 67.3 24 68.5 L 23 71.5 L 23.5 73 Q 20.9 73.8 22 70.5 L 24 67.5 L 23.5 66 Z "
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 28.5 66 L 30.5 67 L 32.5 66 L 32.5 67 L 30.5 68 L 28.5 66 Z "
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 66 L 151 67 L 150.5 70 L 149.5 68 L 148 68.5 Q 148.8 65.9 145.5 67 L 143.5 68 L 143.5 67 L 145.5 66 Z "
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 68 L 141 68.5 L 138.5 69 L 138.5 68 Z "
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 25.5 69 L 28 70.5 L 25 71 L 25.5 69 Z "
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 29.5 70 Q 32.5 71.5 29.5 73 L 29.5 70 Z "
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 72 L 152 72.5 L 151.5 75 L 150 74.5 L 149.5 76 L 149 74.5 L 149.5 72 Z "
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 73 L 35 75.5 L 34.5 77 L 33 74.5 L 34.5 73 Z "
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 73 Q 146.3 72.3 147 74.5 Q 148.1 77.8 145.5 77 L 146 75.5 Q 146.9 72.5 142.5 74 L 142.5 73 Z "
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 75 L 144 75.5 L 141.5 77 L 142.5 75 Z "
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 22.5 77 L 23 78.5 L 21.5 81 L 21 78.5 L 22.5 77 Z "
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 77 L 157.5 79 L 158.5 77 Z "
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 78 L 152 78.5 L 149.5 80 L 150.5 78 Z "
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 78 L 157 80.5 L 155.5 86 L 155 81.5 L 155 79.5 L 155.5 78 Z "
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 79 L 35 82.5 L 34 82.5 L 34.5 79 Z "
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 31.5 80 L 33 82.5 L 30.5 83 L 28 82.5 L 31 82 L 31.5 80 Z "
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 80 L 147 82 L 144 81.5 L 146.5 80 Z "
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 81 L 152 83 L 150 82.5 L 151.5 81 Z "
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 21.5 82 L 22.5 84 L 21.5 82 Z "
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 84 L 152 85.5 L 149.5 92 L 149 89.5 L 150 86 L 146 87.5 L 146.5 89 L 143.5 87 L 142.5 85 L 144.5 86 L 149.5 85 L 151 85.5 L 151.5 84 Z "
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33.5 85 L 35 88.5 L 34 88.5 L 33.5 86 L 30.5 90 L 30 88.5 L 30.5 86 L 33.5 85 Z "
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 22.5 86 L 24 89.5 L 22 90.5 L 22.5 86 Z "
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 27.5 86 L 29 86.5 L 27 87.5 L 27.5 89 Q 24.5 87.5 27.5 86 Z "
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 86 L 139 88.5 L 138 88.5 L 138.5 86 Z "
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 87 L 142.5 89 L 141.5 87 Z "
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 89 Q 157.2 90.3 155 91.5 L 156 93.5 L 154 92.5 L 155 90.5 L 154.5 89 Z "
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 90 L 141 91 L 142 93.5 L 140.5 94 L 138 92.5 L 137.5 94 L 137 92.5 L 138.5 90 Z "
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 26.5 91 L 27.5 93 Q 24.7 93.7 26.5 91 Z "
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 91 L 160 92.5 L 159 95.5 L 158.5 97 L 158 95.5 L 159 94.5 L 157.5 92 L 159 92.5 L 159.5 91 Z "
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 93 Q 146.8 92.3 146 94.5 L 144.5 93 Z "
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 19 97 L 21 97.5 L 19 98.5 L 19 97 Z "
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 24.5 97 L 25.5 99 L 24.5 97 Z "
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 97 L 148.5 99 L 149.5 97 Z "
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 97 L 157 99.5 L 156 99.5 L 156.5 97 Z "
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 98 L 141 100 L 139 99.5 L 140.5 98 Z "
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147 100 Q 150 99 149 102 Q 146 103 147 100 Z "
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 101 L 139 102.5 L 138 105 L 140 105 Q 138.7 100.9 142 102 L 141 105.5 L 142.5 108 L 141 108.5 L 142 114 L 139.5 113 L 139 114.5 L 142 115.5 L 140.5 117 L 136 112.5 L 136 110.5 L 136.5 109 L 139.5 111 Q 137.9 109.3 141 107.5 Q 141.8 105.3 139.5 106 L 136.5 107 L 135 105.5 L 137 105 L 136 102.5 L 138.5 101 Z "
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 103 L 146.5 105 L 145.5 103 Z "
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154 104 L 156 104.5 L 156 112 L 154 111.5 L 154 104 Z "
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 22.5 105 L 23.5 107 L 22.5 105 Z "
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 105 L 35 107.5 L 36 109.5 L 34 110.5 L 33.5 109 L 31 109.5 L 30.5 111 L 30 108 L 32.5 109 L 33.5 107 L 31 106.5 L 34.5 105 Z "
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 28.5 107 L 29 109.5 L 28 109.5 L 28.5 107 Z "
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 41.5 107 L 41 108.5 L 43 111.5 L 40 109.5 L 41.5 107 Z "
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 19.5 108 L 20.5 110 L 19.5 108 Z "
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 24.5 108 L 26 110.5 L 25.5 113 L 22 110.5 Q 21.3 108.3 23.5 109 L 24.5 108 Z "
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 109 L 144 110.5 L 143.5 112 L 143 110.5 L 144.5 109 Z "
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 111 L 149.5 113 L 148.5 112 L 146 113.5 L 148.5 111 Z "
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 30.5 112 L 34 113.5 L 32 113.5 L 33 115.5 L 31 114.5 L 30.5 112 Z "
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 37.5 112 L 38.5 115 L 40 114.5 L 39.5 116 L 42.5 114 L 43.5 116 L 45 115.5 L 44 117.5 L 44.5 119 Q 41.2 120.1 42 117.5 L 39.5 117 L 38 118.5 L 37 121.5 L 37.5 123 L 35 117.5 L 35 115.5 Q 33.9 112.2 36.5 113 L 37.5 112 Z M 38 116 L 37 118 L 39 117 L 38 116 Z "
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 26.5 114 L 27.5 116 L 26.5 114 Z "
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 115 L 126 117.5 L 125 117.5 L 125.5 115 Z "
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132 115 L 135.5 116 Q 136.7 113.7 138 116.5 L 137.5 118 L 139 118.5 L 137.5 119 L 136 118.5 L 135.5 120 L 132 115 Z "
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 117 L 147.5 120 L 146 119.5 L 145 123.5 L 145.5 125 L 143 126.5 L 145.5 130 L 140 123.5 L 147.5 117 Z "
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 29.5 119 L 31 119.5 L 28.5 123 L 28 120.5 L 29.5 119 Z "
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128 119 Q 131.8 117.5 131 120.5 L 128 124.5 L 129 127 L 126 127.5 L 128 130.5 Q 126.5 133.5 125 130.5 L 127 130.5 Q 127.8 128.3 125.5 129 L 124 128.5 L 123 130.5 Q 127.3 132.7 122.5 135 L 124 132.5 L 122 130.5 L 121.5 129 Q 118 130 119 135.5 L 121 135.5 L 118 136.5 L 117.5 138 L 117 136.5 L 118 134 L 115 134.5 Q 117.3 135.8 114.5 137 L 114 134.5 L 116 127.5 L 115.5 126 L 118 127.5 Q 117.2 130.1 120.5 129 Q 121.8 126 126 127 L 128 119 Z "
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 43.5 120 L 46 121.5 L 44 122.5 L 47 123.5 Q 42.8 123.3 41.5 126 L 41 124.5 L 41 122.5 L 43.5 120 Z "
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 120 L 119.5 122 L 120.5 120 Z "
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 120 L 136 122.5 L 132.5 127 Q 130.3 126.3 131 128.5 L 130 128.5 L 131.5 126 Q 133.8 126.8 133 124.5 L 131.5 125 L 130 124.5 L 133 122.5 Q 132.3 120.3 134.5 121 Q 136 123.5 137.5 120 Z M 135 122 L 133 124 L 135 124 L 135 122 Z "
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 31.5 121 Q 34.3 122.2 32 123.5 L 29.5 127 L 29.5 124 L 31 124.5 L 32 122.5 L 31.5 121 Z "
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 121 L 125.5 123 L 126.5 121 Z "
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 122 L 116.5 124 L 117.5 122 Z "
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 54.5 124 L 56 126.5 L 54.5 129 L 57.5 131 L 59 130.5 L 56.5 134 L 57 132.5 L 56.5 131 L 53 131.5 L 54 129.5 L 51 131.5 L 51 133.5 L 50.5 135 L 50 133.5 L 50 131.5 Q 50.8 128.9 47.5 130 L 48.5 133 Q 44.3 131.3 47 129.5 L 47.5 126 L 49.5 126 L 52.5 125 L 54 125.5 L 54.5 124 Z "
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 125 L 111.5 127 L 110 126.5 L 112.5 125 Z "
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 35.5 126 L 37.5 129 L 35.5 126 Z "
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 127 L 142 132.5 L 141 132.5 Q 141.8 130.3 139.5 131 L 138 131.5 L 140 129.5 L 138.5 127 Z "
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 28.5 128 L 27.5 130 L 28.5 128 Z "
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 32.5 129 L 33 130.5 L 31 131.5 L 32.5 129 Z "
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 39.5 129 L 40 131 L 42 131.5 L 37.5 134 L 38.5 132 L 40 131.5 L 39.5 129 Z "
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 129 L 69.5 129 L 73 130.5 L 71.5 131 L 69.5 130 L 66 130.5 L 67.5 129 Z "
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103 129 L 105 129.5 L 103 130.5 L 103 129 Z "
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 129 L 110 130.5 L 106.5 131 L 107.5 129 Z "
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 63.5 130 L 65 132.5 L 63.5 135 L 63 133.5 L 63 131.5 L 63.5 130 Z "
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 130 Q 136.8 128.9 136 131.5 L 134.5 131 L 133.5 130 Z "
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 35 131 L 37 131.5 L 35 132.5 L 35 131 Z "
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82 132 L 84 132.5 L 82.5 135 L 82 132 Z "
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 132 L 90.5 133 L 92 132.5 Q 92.8 135.1 89.5 134 L 84.5 135 L 84.5 134 L 89 133.5 Q 84.6 133.9 85.5 132 Z "
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 132 L 98 133.5 L 97.5 135 L 96.5 133 L 98.5 132 Z "
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 42.5 133 L 41.5 135 L 42.5 133 Z "
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 133 L 130.5 135 L 132.5 134 L 131.5 136 L 128.5 138 L 129.5 135 L 126.5 137 L 128.5 134 L 130.5 133 Z "
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 133 L 148.5 135 L 147.5 133 Z "
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 52.5 134 L 55 135 L 56 137.5 L 53.5 136 Q 50.7 136.7 52.5 134 Z "
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 111.5 134 L 112.5 136 L 111.5 134 Z "
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 134 L 138.5 138 L 137 137.5 L 141.5 134 Z "
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 134 L 144 135.5 L 142 136.5 L 143.5 134 Z "
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 30.5 135 L 31 137 L 33 137.5 L 31.5 138 L 30.5 135 Z "
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 39.5 135 L 41.5 138 L 39.5 135 Z "
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 46.5 136 L 53 140.5 L 54.5 144 L 57 142.5 L 56.5 145 L 52.5 145 Q 50.3 145.8 51 143.5 L 52 140.5 L 50.5 141 L 49 141.5 L 49.5 143 Q 47.7 139.9 46 141.5 Q 45.3 139.3 47.5 140 L 49.5 140 L 51 139.5 L 47.5 137 L 45 138 L 44.5 140 L 44 138.5 L 46.5 136 Z "
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 59.5 136 L 60.5 138 L 59.5 136 Z "
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 136 Q 77.3 135 76 138 L 73.5 136 Z "
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102.5 136 Q 104.8 136.8 104 140.5 L 103 140.5 L 102.5 136 Z "
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 137 L 125.5 139 L 124.5 137 Z "
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 138 L 97.5 140 L 98.5 138 Z "
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 139 L 90 143.5 L 88.5 143 L 86.5 142 L 84 143 L 84.5 141 L 86.5 141 Q 89 141.7 88.5 139 Z "
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 139 L 111.5 141 L 112.5 139 Z "
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 139 L 137.5 140 L 139.5 139 L 139.5 140 L 135.5 143 L 134 140.5 L 135.5 139 Z "
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 140 Q 122.5 141.5 119.5 143 L 117 142.5 L 119.5 140 Z "
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143 140 L 145 140.5 L 143.5 143 L 146 143.5 L 143.5 145 L 143 143 L 141 143.5 Q 143.3 144.8 140.5 146 L 139 143.5 L 143 142 L 143 140 Z "
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 36.5 141 L 40 143.5 L 38.5 143 L 36.5 141 Z "
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 42.5 141 L 42 142.5 L 41.5 144 L 41 142.5 L 42.5 141 Z "
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 143 L 115 145.5 L 113.5 146 L 111 144.5 L 113.5 143 Z "
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 143 L 130.5 146 L 132.5 143 Z "
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 144 L 40 148.5 L 38.5 149 Q 36.8 145.9 35 147.5 L 36 146.5 L 34.5 144 Z "
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 144 L 78 144.5 L 73.5 145 L 73.5 144 Z "
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 65.5 145 L 67 149.5 L 65 148.5 L 65.5 145 Z "
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 145 L 86 145.5 L 83.5 146 L 83.5 145 Z "
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108 145 L 110 145.5 Q 107.8 146.8 110.5 148 L 112 147.5 L 113 151.5 L 111 150.5 L 108 145 Z "
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 43.5 146 L 48 148.5 L 46.5 149 L 43.5 146 Z "
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 146 L 104.5 148 L 105.5 146 Z "
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 146 L 141.5 148 L 142.5 146 Z "
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 147 L 99.5 150 L 101.5 147 Z "
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 147 L 123 148.5 L 121.5 151 L 119.5 150 L 119.5 152 Q 116.5 150.5 119.5 149 L 121.5 150 L 123.5 147 Z "
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 147 L 140 148.5 L 139 150.5 L 139.5 152 L 136.5 151 L 135 151.5 L 135.5 149 L 137.5 150 L 138 148.5 L 137.5 147 Z "
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 148 L 76.5 149 L 78 148.5 Q 76.8 151.3 75.5 149 L 74.5 148 Z "
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 148 L 94 148.5 L 92 149 L 92.5 151 L 95 150 L 94.5 152 L 92.5 152 Q 89.9 152.8 91 149.5 L 92.5 148 Z "
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 95.5 148 L 98 148.5 L 95.5 149 L 95.5 148 Z "
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 148 L 142.5 150 L 141 149.5 L 143.5 148 Z "
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 69.5 149 L 71.5 149 L 73 149.5 L 70.5 151 L 69.5 149 Z "
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 149 L 83.5 152 L 85.5 149 Z "
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 149 L 86.5 152 L 88.5 149 Z "
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 149 L 107 151.5 L 106 151.5 L 106.5 149 Z "
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 149 L 116.5 151 L 115.5 149 Z "
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 150 L 79 152.5 L 80 154.5 L 78.5 155 L 77 153.5 L 78.5 150 Z "
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 55.5 152 L 58 152.5 L 58.5 154 Q 59.8 151.8 61 154.5 L 57.5 154 L 55.5 152 Z "
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 115.5 152 L 117 152.5 L 114.5 154 L 115.5 152 Z "
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 153 L 109 153.5 L 107 154.5 L 109 155.5 L 106.5 157 L 106 154.5 L 107.5 153 Z "
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 153 L 111.5 155 L 110 154.5 L 112.5 153 Z "
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 63.5 154 L 67 156.5 L 65.5 156 L 63.5 154 Z "
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 156 L 92 158 L 94 158.5 L 90.5 159 L 88 157.5 L 89.5 157 L 91 157.5 L 91.5 156 Z "
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 156 L 97.5 158 L 96.5 156 Z "
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 156 L 102 156.5 L 99.5 158 L 100.5 156 Z "
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 157 L 75.5 158 L 77.5 157 L 78.5 159 L 76.5 158 L 74.5 159 L 73.5 157 Z "
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 157 Q 87.9 155.5 87 158.5 L 85.5 158 L 82.5 159 L 83.5 157 Z "
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102.5 160 L 103 162 L 101 161.5 L 102.5 160 Z "
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 69.5 161 L 73 161.5 L 69.5 162 L 69.5 161 Z "
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75.5 162 L 79 162.5 L 75.5 163 L 75.5 162 Z "
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84 162 Q 89.4 160.5 91 163.5 L 88.5 164 L 86.5 163 L 84 164 L 84 162 Z "
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 162 L 95 162.5 L 92.5 163 L 92.5 162 Z "
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 164 L 82 164.5 L 78.5 165 L 78.5 164 Z "
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 164 L 95 164.5 L 92.5 166 L 93.5 164 Z "
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 13 L 78.5 15 L 77 14.5 L 79.5 13 Z "
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 13 L 96 14.5 L 94.5 15 L 93.5 13 Z "
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88 19 L 90 19.5 L 88 20.5 L 88 19 Z "
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 20 L 83 20.5 L 80.5 21 L 80.5 20 Z "
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83 22 L 85 22.5 L 84.5 24 L 86 24.5 L 84.5 25 L 82.5 25 L 81 24.5 L 83 24 L 83 22 Z "
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88 22 L 90 22.5 L 89 24.5 L 89.5 26 L 88 26 L 88 22 Z "
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 24 L 96.5 26 L 97.5 24 Z "
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 51.5 29 Q 54.5 30.5 51.5 32 L 51.5 29 Z "
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 40.5 31 L 37.5 35 L 40.5 31 Z "
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 31 L 134.5 35 L 131.5 31 Z "
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 49.5 34 L 48.5 36 L 47 35.5 L 49.5 34 Z "
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 37 L 139.5 39 L 138.5 37 Z "
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 38 L 124.5 41 L 126.5 38 Z "
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56.5 39 L 55.5 41 L 56.5 39 Z "
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 41 L 132.5 43 Q 129.7 43.7 131.5 41 Z "
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 42 L 121.5 44 L 120.5 42 Z "
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 43 L 134.5 45 L 135.5 43 Z "
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 44 L 131.5 47 Q 128.5 45.5 131.5 44 Z "
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 49 L 87.5 51 Q 85.8 48.3 84 52.5 Q 83.3 54.8 85.5 54 L 88 52.5 L 89.5 55 L 91.5 54 Q 94.5 55.6 93 61 L 86 61.5 Q 89.7 63.2 86.5 65 L 81 59.5 L 81 57.5 L 81 55.5 L 86.5 49 Z M 85 57 L 83 61 L 86 60 L 85 57 Z M 89 57 L 86 59 L 89 60 L 92 60 L 89 57 Z "
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 50 L 134 51.5 L 133.5 54 Q 130.8 52.8 133 51.5 L 133.5 50 Z "
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 28.5 61 L 31 62.5 L 29.5 63 L 28.5 61 Z "
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 67 Q 87.8 66.3 87 68.5 L 88 70.5 L 87.5 72 Q 90.1 71.3 89 74 L 86.5 75 L 86 72.5 L 87 70.5 L 85 69.5 L 85.5 67 Z "
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 21.5 68 L 20.5 70 L 21.5 68 Z "
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152 71 L 154 71.5 L 152 72.5 L 152 71 Z "
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 75 L 87.5 76 L 89 75.5 Q 89.8 77.8 87.5 77 L 85.5 77 Q 82.7 77.7 84.5 75 Z "
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 77 L 145.5 79 Q 142.7 79.7 144.5 77 Z "
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 19.5 78 L 20 83.5 L 19 83.5 L 19.5 78 Z "
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 78 L 138 81.5 L 137 81.5 L 137.5 78 Z "
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 81 L 86 82.5 L 86.5 84 L 88 83.5 Q 86.5 86.5 85 83.5 L 86.5 81 Z "
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 87 L 90 88.5 L 88 89.5 L 89.5 87 Z "
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 91 Q 85.8 89.9 85 92.5 L 83.5 92 L 82.5 91 Z "
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 28.5 93 L 29.5 95 L 28.5 93 Z "
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 25.5 95 L 28 96.5 L 26.5 97 L 25.5 95 Z "
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91 96 L 94 96.5 L 91.5 98 L 91 96 Z "
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 29 99 L 31 99.5 L 29 100.5 L 29 99 Z "
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 99 L 141.5 101 L 142.5 99 Z "
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 104 L 89 106 L 87 105.5 L 88.5 104 Z "
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 107 Q 84.8 105.9 84 108.5 L 82.5 108 L 81.5 107 Z "
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 35.5 122 L 36.5 124 L 34.5 124 L 33 123.5 L 35.5 122 Z "
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 125 L 135.5 127 L 136.5 125 Z "
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 131 L 105.5 136 L 104 132.5 L 105.5 131 Z "
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 134 L 110.5 136 L 109.5 134 Z "
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 126.5 134 L 125.5 136 L 126.5 134 Z "
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 136 L 143.5 138 L 144.5 136 Z "
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80 137 Q 82.7 135.9 82 138.5 L 80 139.5 L 80 137 Z "
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 141 L 35.5 143 L 34.5 141 Z "
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 141 L 97.5 143 L 96.5 141 Z "
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 68.5 152 L 69.5 154 L 68.5 152 Z "
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 154 L 93 155.5 L 91.5 155 L 90.5 154 Z "
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(30,17,12)",
    stroke: "rgb(30,17,12)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75.5 159 L 74.5 161 L 75.5 159 Z "
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(214,242,31)",
    stroke: "rgb(214,242,31)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 32 Q 88.8 31.3 88 33.5 L 95 46 Q 103.7 43.8 109.5 38 L 112 38 L 111 41.5 L 111 43.5 L 112 45.5 L 111 47.5 Q 113.5 49 112 54.5 L 113.5 56 L 126.5 56 L 127.5 55 L 129 57.5 Q 123.3 63.6 121 72 L 135 79 Q 136.7 83.1 132.5 82 L 121 89.5 L 129 105 L 112 105 L 112 111.5 Q 109.8 112.7 111 117.5 L 111 119.5 L 112 121.5 Q 110.3 124.8 108.5 121 L 97 114.5 L 99.5 114 L 108.5 119 L 110 117.5 L 110 105.5 L 111.5 104 L 114.5 103 L 119.5 104 L 126 102.5 L 120 91.5 L 120 88.5 L 131 80.5 L 129.5 78 L 120 72.5 L 120 68.5 L 126 58.5 L 124.5 57 L 112.5 57 L 110 54.5 L 110 41.5 L 108.5 41 L 96.5 48 L 93 45.5 L 86.5 35 L 78.5 47 L 75.5 47 L 64 41 L 64 54.5 L 62.5 56 L 60.5 57 L 48 57 L 49 61.5 L 54 68.5 L 54 71.5 L 41 80.5 L 54 88.5 L 54 91.5 L 48 100.5 L 48 103 L 55.5 104 L 59.5 103 L 63 105.5 L 64 119 L 77 114 L 77.5 112 L 78.5 114 L 79.5 108 L 80 114 L 87.5 114 L 88 115.5 L 90.5 114 Q 97.4 112 96 116 Q 93.3 114.9 94 117.5 L 88 129 L 85 127.5 L 77.5 115 L 62 123 L 62 106.5 L 60.5 105 L 44.5 105 L 44 103 Q 46.7 104.1 46 101.5 L 52 89.5 Q 46.6 83.5 38 82 Q 36.5 78.3 39.5 79 L 52 71.5 L 48 61.5 L 44 56.5 Q 45.3 53.7 46.5 56 L 52.5 55 Q 53.8 57.3 58.5 56 L 62 55 L 62 38.5 L 63.5 38 L 77.5 46 L 86.5 32 Z M 82 115 L 83 116 L 82 118 L 84 123 L 88 125 L 92 118 Q 91 115 90 117 L 87 115 L 86 117 L 85 117 Q 86 113 82 115 Z "
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(214,242,31)",
    stroke: "rgb(214,242,31)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 45 L 89 47.5 L 88 47.5 L 88.5 45 Z "
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(214,242,31)",
    stroke: "rgb(214,242,31)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 47 L 86 48.5 L 84 49.5 L 85.5 47 Z "
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(214,242,31)",
    stroke: "rgb(214,242,31)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 48 Q 93.1 47.2 92 50.5 L 91 50.5 L 90.5 49 L 89.5 54 L 89 49.5 L 90.5 48 Z "
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(214,242,31)",
    stroke: "rgb(214,242,31)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 51 L 82 52.5 L 81.5 54 L 81 52.5 L 82.5 51 Z "
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(214,242,31)",
    stroke: "rgb(214,242,31)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 52 Q 94.5 52.5 94 56.5 L 93 56.5 L 91.5 52 Z "
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(214,242,31)",
    stroke: "rgb(214,242,31)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 56 L 80 59.5 L 78.5 62 L 78 60.5 L 78.5 59 Q 75.4 59.7 77.5 56 Z "
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(214,242,31)",
    stroke: "rgb(214,242,31)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 61 Q 92.5 62.5 89.5 64 L 89.5 61 Z "
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(214,242,31)",
    stroke: "rgb(214,242,31)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 63 L 83.5 65 Q 80.7 65.7 82.5 63 Z "
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(214,242,31)",
    stroke: "rgb(214,242,31)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 67 L 91 68.5 L 90.5 72 L 90 68.5 L 91.5 67 Z "
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(214,242,31)",
    stroke: "rgb(214,242,31)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 71 L 84 76.5 L 83 76.5 L 82.5 71 Z "
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(214,242,31)",
    stroke: "rgb(214,242,31)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 76 L 92.5 78 Q 89.7 78.7 91.5 76 Z "
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(214,242,31)",
    stroke: "rgb(214,242,31)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 77 L 83 85.5 L 82 85.5 L 81.5 77 Z "
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(214,242,31)",
    stroke: "rgb(214,242,31)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 80 L 94 82.5 L 92 83.5 L 92.5 80 Z "
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(214,242,31)",
    stroke: "rgb(214,242,31)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 84 L 94 87.5 L 96 90.5 L 93 88.5 Q 92.3 84.8 94.5 84 Z "
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(214,242,31)",
    stroke: "rgb(214,242,31)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 88 L 82 95.5 L 81 95.5 L 80 90.5 L 81.5 88 Z "
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(214,242,31)",
    stroke: "rgb(214,242,31)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 92 L 97 97.5 L 96 99.5 L 96.5 101 Q 93.5 101.9 95 97.5 Q 97.5 96 94 94.5 L 94.5 92 Z "
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(214,242,31)",
    stroke: "rgb(214,242,31)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 98 L 83.5 100 Q 80.7 100.7 82.5 98 Z "
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(214,242,31)",
    stroke: "rgb(214,242,31)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 100 L 81 103.5 L 80 103.5 L 80.5 100 Z "
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(214,242,31)",
    stroke: "rgb(214,242,31)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 103 L 97 104.5 L 96.5 107 L 96 104.5 L 97.5 103 Z "
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(214,242,31)",
    stroke: "rgb(214,242,31)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97 108 Q 99.7 106.9 99 109.5 L 97.5 112 L 97 108 Z "
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(214,242,31)",
    stroke: "rgb(214,242,31)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 110 L 83.5 112 L 82.5 110 Z "
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(214,242,31)",
    stroke: "rgb(214,242,31)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 110 L 96 110.5 L 93.5 112 L 94.5 110 Z "
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 12 L 95 12.5 L 92.5 13 L 92.5 12 Z "
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 17 L 84 18.5 L 82.5 18 L 81.5 17 Z "
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 17 L 91 19.5 L 90 19.5 L 89.5 17 Z "
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 17 L 95 17.5 L 92.5 18 L 92.5 17 Z "
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 19 L 75.5 21 L 74.5 19 Z "
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 23 L 89 27.5 Q 87.5 30.5 86 27.5 L 87 25.5 Q 84.7 24.3 87.5 23 Z "
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 47.5 24 L 46.5 26 L 47.5 24 Z "
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 60.5 25 L 61.5 27 L 60.5 25 Z "
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 25 L 83 25.5 L 80.5 27 L 81.5 25 Z "
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 25 L 101 27.5 L 99 28.5 L 99 26.5 L 99.5 25 Z "
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 26 L 74.5 28 L 73.5 26 Z "
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 26 L 129.5 28 L 128.5 26 Z "
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 42.5 28 L 41.5 30 L 42.5 28 Z "
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 54.5 28 L 55.5 30 L 54.5 28 Z "
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 29 L 105.5 31 L 103.5 32 L 104.5 30 L 106.5 29 Z "
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 46.5 30 L 47.5 32 L 46.5 30 Z "
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 30 L 117.5 32 L 116.5 30 Z "
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 30 L 119.5 32 L 120.5 30 Z "
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 31 L 110.5 32 L 112 31.5 L 111.5 34 L 109.5 33 L 108 33.5 L 108.5 31 Z "
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 36.5 34 L 35.5 36 L 36.5 34 Z "
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 58.5 35 L 59.5 37 L 57.5 37 L 55 38.5 L 55.5 40 Q 52 38 56.5 36 L 58.5 35 Z "
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 35 L 124.5 37 L 125.5 35 Z "
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 36 L 115.5 38 L 116.5 36 Z "
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 36 L 121.5 38 L 120.5 36 Z "
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 37.5 37 L 36.5 39 L 37.5 37 Z "
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 43.5 39 L 44.5 41 L 43.5 39 Z "
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 49.5 39 L 50.5 41 L 48 40.5 L 49.5 39 Z "
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 40.5 40 L 42.5 43 L 40.5 40 Z "
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 42 L 138 43.5 L 136.5 43 L 134.5 44 L 135.5 42 Z "
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 36.5 43 L 37.5 45 L 36.5 43 Z "
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 129.5 43 L 129.5 46 Q 126.5 44.5 129.5 43 Z "
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33.5 44 L 34.5 46 L 33.5 44 Z "
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 46 L 126.5 48 L 125.5 46 Z "
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 47 L 135.5 49 L 136.5 47 Z "
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 47 L 140.5 49 L 139.5 47 Z "
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 32.5 49 L 33.5 51 L 32.5 49 Z "
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 52 L 139.5 54 L 138.5 52 Z "
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 53 L 142.5 55 L 141.5 53 Z "
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 37.5 54 L 41 54.5 Q 39.8 57.2 38.5 55 L 37.5 54 Z "
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 55 L 144.5 57 L 145.5 55 Z "
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 35.5 56 L 34.5 58 L 35.5 56 Z "
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 60 L 34.5 63 Q 31.5 61.5 34.5 60 Z "
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 62 L 145.5 64 L 144.5 62 Z "
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 22.5 67 L 23 69.5 L 22 69.5 L 22.5 67 Z "
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 68 L 33.5 70 L 34.5 68 Z "
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 30.5 70 L 34 71.5 L 32.5 72 L 30.5 70 Z "
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 71 L 138.5 73 L 137.5 71 Z "
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 21.5 73 L 22 75.5 L 21 75.5 L 21.5 73 Z "
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 35.5 73 L 36 75.5 L 35 75.5 L 35.5 73 Z "
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 73 L 155 75.5 L 154 75.5 L 154.5 73 Z "
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 25.5 79 L 28 79.5 L 25.5 80 L 25.5 79 Z "
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 25.5 81 L 27 83.5 L 25 82.5 L 25.5 81 Z "
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 21.5 84 L 22 86.5 L 21 86.5 L 21.5 84 Z "
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 35.5 84 L 36 86.5 L 35 86.5 L 35.5 84 Z "
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 23.5 86 L 24 88.5 L 23 88.5 L 23.5 86 Z "
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 23.5 91 L 22.5 93 L 23.5 91 Z "
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 96 L 141.5 98 L 140.5 96 Z "
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 39.5 100 L 38 102.5 L 37.5 104 L 37 102 L 35 101.5 L 36.5 101 Q 38 103.5 39.5 100 Z "
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81 109 L 83 109.5 L 82.5 112 L 81 109 Z "
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 125.5 114 L 123.5 117 L 125.5 114 Z "
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33.5 118 L 34.5 120 L 33.5 118 Z "
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 118 L 122 120.5 L 119.5 123 L 121.5 118 Z "
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 37.5 123 L 40 123.5 L 39 124.5 L 41.5 128 L 37.5 123 Z "
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 124 L 141.5 126 L 140.5 124 Z "
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 36.5 126 L 37.5 128 L 35 127.5 L 36.5 126 Z "
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 130 L 100.5 132 L 99.5 130 Z "
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 130 L 142.5 132 L 141.5 130 Z "
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 131 Q 70.5 132.5 67.5 134 L 67.5 131 Z "
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 71.5 131 L 73 131.5 L 71 132.5 L 71.5 134 Q 68.5 132.5 71.5 131 Z "
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 131 L 95 131.5 L 92.5 132 L 92.5 131 Z "
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 131 L 104 135.5 L 103 135.5 L 103.5 131 Z "
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 131 L 108.5 133 L 107.5 131 Z "
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 131 L 135.5 133 L 134.5 131 Z "
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 132 L 129.5 134 L 130.5 132 Z "
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 124.5 133 L 123.5 135 L 124.5 133 Z "
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 45.5 134 L 46.5 136 L 45.5 134 Z "
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 134 L 79.5 136 L 80.5 134 Z "
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 135 L 98.5 137 L 97.5 135 Z "
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 136 Q 116.5 137.5 113.5 139 L 113.5 136 Z "
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 136 Q 133.3 139.1 135 137.5 L 134 138.5 L 135.5 141 L 132 139.5 L 133 138.5 L 131.5 136 Z "
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 136 L 146.5 138 L 147.5 136 Z "
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 137 L 85 138.5 L 83.5 139 L 82.5 137 Z "
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 42.5 138 Q 45.5 139.5 42.5 141 L 41 140.5 L 43 139.5 L 42.5 138 Z "
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 138 L 138.5 141 L 136.5 138 Z "
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 30.5 140 L 32.5 143 L 30.5 140 Z "
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 140 L 35.5 142 L 34.5 140 Z "
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 62.5 140 L 63.5 142 L 62.5 140 Z "
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 140 L 73.5 142 L 74.5 140 Z "
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 140 L 81 145.5 L 79 146 L 78 143.5 L 79.5 140 Z "
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 140 L 141.5 142 L 142.5 140 Z "
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 141 Q 101.8 140.3 101 142.5 L 100.5 145 L 98 143.5 L 100 142.5 L 99.5 141 Z "
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 141 L 122.5 143 L 121.5 141 Z "
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 143 L 137.5 145 L 138.5 143 Z "
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48.5 146 Q 51.5 147.5 48.5 149 Q 45.5 147.5 48.5 146 Z "
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 55.5 146 L 54.5 148 L 55.5 146 Z "
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 61.5 148 L 62.5 150 L 61.5 148 Z "
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 148 L 90 148.5 L 83.5 149 L 83.5 148 Z "
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 148 L 132.5 150 L 131.5 148 Z "
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114.5 149 L 115.5 151 L 114.5 149 Z "
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 150 L 70 151.5 L 68.5 151 L 67.5 150 Z "
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 150 L 113.5 152 L 112.5 151 L 110 152.5 L 112.5 150 Z "
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 150 L 120.5 152 L 119.5 150 Z "
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 151 L 75 152.5 L 73.5 152 L 72.5 151 Z "
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 66.5 154 L 67.5 156 L 66.5 154 Z "
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 154 L 107 155.5 L 105.5 155 L 104.5 154 Z "
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 154 L 109.5 156 L 108.5 154 Z "
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 155 L 81 156.5 Q 81.8 159.1 78.5 158 L 78.5 157 L 80 156.5 L 78.5 155 Z "
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(228,228,225)",
    stroke: "rgb(228,228,225)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 155 L 98.5 157 L 99.5 155 Z "
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,10,0)",
    stroke: "rgb(0,10,0)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 22 L 74 23.5 L 73.5 25 L 73 23.5 L 74.5 22 Z "
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,10,0)",
    stroke: "rgb(0,10,0)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 30 Q 90.8 28.2 99.5 31 L 113.5 37 L 123 44 L 130 53.5 L 135 63.5 L 137 71.5 L 137 88.5 Q 132.8 109.3 118.5 120 Q 111.6 127.1 99.5 129 L 99.5 128 L 111.5 124 L 121 117 Q 119.9 114.3 122.5 115 Q 131.1 106.6 135 93.5 L 136 88.5 L 136 71.5 Q 131.7 52.3 118.5 42 L 105.5 34 L 95.5 31 L 78.5 31 L 71.5 33 L 71.5 32 L 77.5 30 Z "
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,10,0)",
    stroke: "rgb(0,10,0)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 67.5 33 L 70 33.5 L 60.5 38 L 51 45 L 40 62.5 L 37 75.5 L 36.5 85 L 36 75.5 L 39 62.5 L 44 52.5 L 54.5 41 L 67.5 33 Z "
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,10,0)",
    stroke: "rgb(0,10,0)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 37.5 56 L 38 57.5 L 36 58.5 L 37.5 56 Z "
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,10,0)",
    stroke: "rgb(0,10,0)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 72 L 84.5 74 L 85.5 72 Z "
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,10,0)",
    stroke: "rgb(0,10,0)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 74 L 86.5 76 L 87.5 74 Z "
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,10,0)",
    stroke: "rgb(0,10,0)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 82 L 90.5 84 L 89.5 82 Z "
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,10,0)",
    stroke: "rgb(0,10,0)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 37.5 86 Q 40.7 109.3 56.5 120 L 71.5 128 L 80.5 130 L 93.5 130 L 97.5 129 L 97.5 130 L 94.5 131 L 79.5 131 Q 59.9 127.1 49 114.5 L 39 98.5 L 37 91.5 L 37.5 86 Z "
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,10,0)",
    stroke: "rgb(0,10,0)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 135 L 100.5 137 L 99.5 135 Z "
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 13 L 93 13.5 L 81.5 14 L 81.5 13 Z "
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 14 L 77 14.5 L 70.5 16 L 70.5 15 L 73.5 14 Z "
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 14 L 104 15.5 L 101.5 16 L 96.5 15 L 96.5 14 Z "
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 65.5 16 L 69 16.5 L 61.5 19 L 61.5 18 L 65.5 16 Z "
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 16 L 108 16.5 L 105.5 17 L 105.5 16 Z "
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 17 L 113 18.5 L 111.5 19 L 109.5 17 Z "
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 58.5 19 L 60 19.5 L 53.5 23 L 54.5 21 L 58.5 19 Z "
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 19 L 84 20.5 L 83.5 22 L 83 20 L 81.5 19 Z "
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93 19 Q 95.7 17.9 95 20.5 L 96 22.5 L 95 22.5 Q 95.7 19.9 93 21 L 93 19 Z "
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 19 L 99 24.5 L 97.5 27 L 96 24.5 L 98 24.5 L 98.5 19 Z "
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114.5 19 L 117 20.5 L 115.5 21 L 114.5 19 Z "
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 70.5 20 Q 74.3 19.3 75 21.5 L 73.5 21 Q 69.5 21.8 70.5 20 Z "
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 21 L 81 24.5 L 79 25.5 L 80.5 21 Z "
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 21 L 122 23.5 L 120.5 23 L 118.5 21 Z "
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 22 L 109 25.5 L 108 25.5 L 107.5 22 Z "
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 51.5 23 L 50.5 25 Q 40.3 30.3 34 39.5 L 26.5 52 L 27 50.5 Q 33.2 35.7 45.5 27 L 51.5 23 Z "
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 69.5 23 L 76 26.5 L 74.5 26 L 69 25 L 69.5 23 Z "
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102.5 23 L 103 25.5 L 102 25.5 L 102.5 23 Z "
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 24 L 130 28 Q 128.9 30.7 131.5 30 L 143 43.5 L 140 41.5 L 131.5 31 Q 124.8 28.2 123.5 24 Z "
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 27 L 110.5 29 L 111.5 27 L 112 28.5 L 111 31 Q 107.2 32.2 109.5 27 Z "
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 116.5 28 L 115 30.5 L 114.5 33 L 114 30.5 L 116.5 28 Z "
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 28 L 122 30.5 L 121 30.5 L 120.5 28 Z "
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 52.5 29 L 53.5 31 L 51 30.5 L 52.5 29 Z "
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 32 L 121 33 L 119.5 36 L 117 35.5 L 120 34.5 L 118.5 32 Z "
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 47 33 L 49 33.5 L 47 34.5 L 47 33 Z "
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 53.5 35 L 54 37 L 52 36.5 L 53.5 35 Z "
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48.5 36 L 50.5 39 L 48.5 36 Z "
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 36 L 130 36.5 L 124 41.5 L 128.5 36 Z "
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 42.5 37 L 48 41.5 L 46.5 45 L 47 43.5 Q 47.5 38.5 43.5 38 L 42.5 37 Z "
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 39 L 133 41.5 L 130 41.5 L 132.5 39 Z "
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 39.5 41 L 42.5 45 L 39.5 41 Z "
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 42 L 127.5 44 L 128.5 42 Z "
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 36.5 44 L 36 45.5 L 35 50 L 41 52.5 L 38.5 53 L 34 49.5 L 36.5 44 Z "
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 44 L 134.5 46 L 130.5 49 L 130 46.5 Q 131.8 48.1 133.5 45 L 135.5 44 Z "
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 45 L 144.5 47 L 143.5 45 Z "
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 48 L 139 48.5 L 136.5 50 L 137.5 48 Z "
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 48 L 147 50.5 L 145 49.5 L 145.5 48 Z "
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 42.5 49 L 41.5 51 L 42.5 49 Z "
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 50 L 141 52.5 L 140 52.5 L 140.5 50 Z "
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 52 L 138 54.5 L 134.5 56 L 133.5 54 L 137 55 L 137.5 52 Z "
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 52 Q 151.3 57.2 152 65.5 L 151 65.5 L 147.5 52 Z "
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 29.5 56 L 34 58.5 L 32.5 59 L 29.5 56 Z "
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 58 L 144.5 60 L 143.5 58 Z "
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 60 L 140 60.5 L 137.5 62 L 138.5 60 Z "
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 22.5 61 L 23 63.5 L 22 63.5 L 22.5 61 Z "
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 29.5 61 L 27 64.5 L 28.5 68 L 31 68.5 L 28.5 69 Q 25.5 68.5 26 64.5 L 27 62 L 29.5 61 Z "
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 31.5 62 L 35 64.5 Q 35.5 68.5 32.5 69 L 34 66.5 L 32.5 63 L 31.5 62 Z "
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 21.5 65 L 22 67.5 L 21 67.5 L 21.5 65 Z "
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 67 L 153 70.5 L 152 70.5 L 152.5 67 Z "
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 20.5 70 L 21 89.5 L 20 89.5 L 20.5 70 Z "
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 70 L 89 70.5 Q 86.9 73.8 86.5 70 Z "
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 71 L 148 72.5 L 147.5 74 L 147 72 Q 143.7 72.8 144.5 71 Z "
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 72 L 143 72.5 L 140.5 73 L 140.5 72 Z "
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 72 L 154 88.5 L 153 88.5 L 153.5 72 Z "
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 31.5 73 L 30.5 75 Q 28.3 74.3 29 76.5 L 28 76.5 Q 26.8 72.8 30.5 74 L 31.5 73 Z "
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 24.5 74 L 25 78 L 32 78.5 L 25.5 79 Q 22.8 77.8 24.5 74 Z "
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 78 L 144 78.5 L 141 79 L 141 83 L 148.5 83 L 148.5 84 Q 141.7 85.8 140 82.5 Q 139.3 78.8 141.5 78 Z "
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 24 84 L 32 84.5 L 25 85 L 24.5 88 L 24 84 Z "
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 32.5 89 L 33 91.5 L 32 91.5 L 32.5 89 Z "
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 89 L 146 90.5 L 143.5 91 L 140.5 90 L 140.5 89 Z "
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 89 L 148 92.5 L 147 92.5 L 147.5 89 Z "
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 90 L 153 93.5 L 152 93.5 L 152.5 90 Z "
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 21.5 92 L 25 104.5 L 24 104.5 L 21 96.5 L 21.5 92 Z "
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 32.5 94 L 34 94.5 L 28.5 96 L 28.5 95 L 32.5 94 Z "
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 95 L 142 95.5 L 139 96 L 138.5 99 L 138 96.5 L 139.5 95 Z "
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 95 L 152 98.5 L 150.5 101 L 150 99.5 L 151.5 95 Z "
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 96 Q 147.8 94.9 147 97.5 L 145.5 97 L 144.5 96 Z "
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 99 L 146 101.5 L 145 101.5 L 145.5 99 Z "
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 32.5 103 L 35 103.5 L 31.5 105 L 32.5 103 Z "
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 28.5 104 L 29.5 106 L 28.5 104 Z "
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 105 L 149 106.5 L 139 123.5 L 147 135.5 L 135.5 145 L 137.5 142 L 146 135.5 L 139 124 L 135 126.5 L 132.5 130 L 121.5 138 L 122.5 136 L 133 129 L 144 114.5 L 148.5 105 Z "
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 25.5 106 Q 31.6 121.4 43.5 131 L 48 134.5 L 44.5 132 L 34 122.5 Q 27.5 115.3 25.5 106 Z "
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33.5 124 L 33 125.5 L 31.5 128 L 32 126.5 L 33.5 124 Z "
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 30.5 129 L 30 130.5 L 28.5 133 L 29 131.5 L 30.5 129 Z "
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 60 130 L 62 130 L 62 136.5 L 63.5 137 L 65 136.5 L 62.5 140 L 60.5 132 L 58 137 L 56 136.5 L 60 130 Z "
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 66.5 132 L 67 133.5 L 65 134.5 L 66.5 132 Z "
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 107.5 133 L 113 137.5 L 111.5 137 Q 108.2 138.1 109 135.5 L 107.5 133 Z "
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 27.5 134 L 35.5 143 L 45 149.5 L 43.5 149 L 28 138 L 27.5 134 Z "
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 69.5 134 L 69 135.5 L 66.5 141 L 66 139.5 L 69.5 134 Z "
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 49.5 135 Q 54.8 140.2 63 142.5 L 61.5 143 L 51.5 138 L 49.5 135 Z "
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 135 L 74 135.5 L 72 136 L 71 140.5 L 72.5 143 Q 69.5 142.5 70 138.5 L 72.5 135 Z "
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 135 L 79 136.5 L 77.5 136 L 76.5 135 Z "
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 135 Q 96.3 134.3 97 136.5 L 96.5 138 L 96 136 Q 91.6 137 92.5 135 Z "
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 90.5 136 L 91 139 L 96 139.5 L 92 140 L 91.5 144 L 90.5 136 Z "
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 136 L 108 137.5 L 106 138 L 105.5 141 L 105.5 136 Z "
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 100.5 137 L 102 141.5 L 101 141.5 L 100.5 137 Z "
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 119.5 138 L 118.5 140 L 113.5 142 L 113.5 141 L 119.5 138 Z "
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 139 L 85 139.5 L 81 141.5 Q 80.4 144.3 86.5 143 L 86.5 144 L 80 144 L 80 140.5 L 81.5 139 Z "
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77 140 L 79 140.5 L 78 143 L 76 142.5 L 77 140 Z "
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 141 L 98.5 143 L 97.5 141 Z "
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110.5 142 L 112 142.5 L 104.5 145 L 104.5 144 L 110.5 142 Z "
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 143 L 69 144.5 L 66.5 145 L 64.5 143 Z "
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 70.5 145 L 81 146.5 L 75.5 147 L 70.5 146 L 70.5 145 Z "
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 145 L 103 145.5 L 99.5 146 L 99.5 145 Z "
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 145 L 132.5 147 L 116.5 155 L 116.5 154 L 133.5 145 Z "
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 93.5 146 L 98 146.5 L 93.5 147 L 93.5 146 Z "
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 147 L 91 147.5 L 82.5 148 L 82.5 147 Z "
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 46.5 150 L 61 156.5 L 58.5 157 L 47.5 152 L 46.5 150 Z "
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 155 L 115 155.5 L 110.5 157 L 110.5 156 L 113.5 155 Z "
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 62.5 157 L 68 158.5 L 65.5 159 L 62.5 158 L 62.5 157 Z "
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 157 L 109 157.5 L 103.5 159 L 103.5 158 L 106.5 157 Z "
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    stroke: "rgb(2,2,2)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 69.5 159 Q 74.3 157.8 75.5 160 L 94.5 160 Q 95.7 157.8 100.5 159 L 100.5 160 Q 95.7 158.8 94.5 161 L 75.5 161 Q 74.3 158.8 69.5 160 L 69.5 159 Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJhuLogo);
export default __webpack_public_path__ + "static/media/jhu-logo.4d5adfaf5a163e43e72f51a5e92c09b2.svg";
export { ForwardRef as ReactComponent };